//
//  * @package         src/components/Dashboard/RightBarComponents
//  * @author          Riddhi D Parekh
//  * @date            02nd November 2018
//  * @type            Question Control File
//  * @description -   This file renders the html and functionality for questions third panel.
//
<template>
  <div ref="questionTab" v-if="controlId">
    <v-wait for="saving question" class="height-zero">
      <template slot="waiting">
        <div id="designLoadingdiv" class="loadingDiv_analytics">
            <div class="loadersec">
              <div class="loader"></div>
            </div>
        </div>
      </template>
    </v-wait>
    <div class="multi_choise_save icon-edit">
      <transition name="bounce">
        <div :class="{'hover_class': saveButtonClassFlag, 'tracey_hover_class': saveTraceyHoverClassFlag, 'save_cancel': true, 'extra_menu': (all.in_status !== vueCommonConfig.SURVEY_PUBLISHED && all.in_survey_type !== 2)}">
          <a href="#" class="btn btn-survey-reguler btn-save-survey btn-save" @click.prevent="(questionUpdated === 1) ? saveQuestion() : validateAndShowTopLoader()">
              <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m486.996094 64.382812-39.378906-39.378906c-16-16.023437-37.695313-25.003906-60.332032-25.003906h-328.617187c-32.40625 0-58.667969 26.261719-58.667969 58.667969v394.664062c0 32.40625 26.261719 58.667969 58.667969 58.667969h394.664062c32.40625 0 58.667969-26.261719 58.667969-58.667969v-328.617187c0-22.636719-8.980469-44.332032-25.003906-60.332032zm-401.664063 68.949219v-53.332031c0-8.832031 7.167969-16 16-16h224c8.832031 0 16 7.167969 16 16v53.332031c0 8.832031-7.167969 16-16 16h-224c-8.832031 0-16-7.167969-16-16zm170.667969 293.335938c-53.011719 0-96-42.988281-96-96 0-53.015625 42.988281-96 96-96s96 42.984375 96 96c0 53.011719-42.988281 96-96 96zm0 0"/></svg>
              <span>save</span>
          </a>
          <i class="fa fa-spinner fa-spin" v-if="false && isLoading"></i>
          <transition name="bounce">
            <div class="sucessIcon" v-if="false && isShowSucessIcon">
              <i aria-hidden="true" class="fa fa-check-square"></i>
            </div>
          </transition>
        </div>
      </transition>
    </div>

    <div v-bar="{scrollThrottle: 30, draggerThrottle: 30, preventParentScroll: true}">
    <div>
      <div
        :class="all.in_status === vueCommonConfig.SURVEY_PUBLISHED || (skipLogicQids && skipLogicQids.has(questionData.in_question_master_id)) ? 'disabledbutton edit_box' : 'edit_box'"
        v-if="controlData.length>=2">
        <h4 class="edit_head">Type</h4>
        <ul class="question_select">
          <li v-for="(control,index) in controlData" :key="index">
            <input
              :id="'qtype_'+index"
              :value="activeType"
              name="type_selected"
              @input="updateType"
              v-bind:checked="index == activeType ? 1 : 0"
              type="radio"
            />
            <label :for="'qtype_'+index">{{control['in_question_name']}}</label>
          </li>
        </ul>
      </div>

      <div class="edit_box" v-if="controlId != '17' ?  controlId != '18' ? 1 : 0 : 0   ">
        <h4 class="edit_head">question</h4>
        <textarea
          :style="controlId == 1 || controlId == 2 ? 'resize:both;' : 'resize:none;'"
          @change="inputChanged"
          v-validate="controlData[activeType] && controlData[activeType]['validation_details_ids'][0]['in_question_type_id'] == vueQueTypeConfig.TYPE_IMAGE ? '' : 'required'"
          name="st_question_title"
          maxlength="1000"
          data-vv-as="Question title"
          v-model="questionData.st_question_title"
          class="form-control"
          rows="3"
        ></textarea>
        <span
          class="error"
          v-if="errors.has('st_question_title')"
        >{{ errors.first('st_question_title') }}</span>
      </div>
      <div
        :class="all.in_status === vueCommonConfig.SURVEY_PUBLISHED && ![vueQueTypeConfig.TYPE_EMAIL,vueQueTypeConfig.TYPE_CAMERA,vueQueTypeConfig.TYPE_SIGNATURE,vueQueTypeConfig.TYPE_QR_AND_BARCODE_READER,vueQueTypeConfig.TYPE_LIST,vueQueTypeConfig.TYPE_YES_NO,vueQueTypeConfig.TYPE_TRUE_FALSE,vueQueTypeConfig.TYPE_OTHER,vueQueTypeConfig.TYPE_TERMS_AND_CONDITIONS,vueQueTypeConfig.TYPE_SATISFACTION,vueQueTypeConfig.TYPE_STAR,vueQueTypeConfig.TYPE_MULTIPLE_TEXT,vueQueTypeConfig.TYPE_MULTIPLE_IMAGE,vueQueTypeConfig.TYPE_NUMBER,vueQueTypeConfig.TYPE_TELEPHONE,vueQueTypeConfig.TYPE_CURRENCY,vueQueTypeConfig.TYPE_INPUT,vueQueTypeConfig.TYPE_DISPLAY,vueQueTypeConfig.TYPE_IMAGE,vueQueTypeConfig.TYPE_DATE,vueQueTypeConfig.TYPE_12_HOURS,vueQueTypeConfig.TYPE_24_HOURS,vueQueTypeConfig.TYPE_START_SCREEN_TEXT,vueQueTypeConfig.TYPE_END_SCREEN_TEXT,vueQueTypeConfig.TYPE_AUDIO,vueQueTypeConfig.TYPE_VIDEO,vueQueTypeConfig.TYPE_DYNAMIC_LIST].includes(controlData[activeType]['validation_details_ids'][0]['in_question_type_id']) ? 'disabledbutton question_type_option opt-select' : 'question_type_option opt-select'"
        v-if="controlData[activeType]"
      >
        <!-- For all other controls as have no child validations -->
        <div>
          <!-- for multiple choice image options -->
          <div
            v-if="controlData[activeType]['validation_details_ids'][0]['in_question_type_id']== vueQueTypeConfig.TYPE_MULTIPLE_IMAGE ? dropzoneOptionsForMultipleChoise.previewTemplate = templateForMultipleChoise() : 0"
          >
            <div :class="all.in_status === vueCommonConfig.SURVEY_PUBLISHED ? 'disabledbutton edit_box' : 'edit_box'">
              <h4 class="edit_head">Answers</h4>

              <div class="">
                <h4 class="edit_head">Image</h4>
                <div class="add_image">
                  <draggable
                    v-validate.initial="'minTwoImage|maxTwentyImage|required'"
                    data-vv-as="below"
                    name="multipleChoiseImageArray"
                    v-model="questionData.imageArray"
                    :options="{handle:'.handle'}"
                    @sort="onSort"
                    class="answer_choies"
                    style="display: block;"
                  >
                    <div
                      class="tooltip-container"
                      style="display: inline-flex; margin-bottom: 5px; width: 100%;"
                      v-for="(value, index) in questionData.imageArray"
                    >
                      <a href="javascript:void(0);" class="delete_icon handle" style="flex: 0 0 10%">
                        <i class="fa fa-arrows" aria-hidden="true"></i>
                      </a>
                      <a
                        href="javascript:void(0);"
                        class="delete_icon serial_number"
                        style="flex: 0 0 10%"
                      >{{index+1}}</a>
                      <input
                        @change="inputChanged"
                        v-model="questionData.imageArray[index].label"
                        type="text"
                        name="imageAnswerLabel[]"
                        class="form-control multiple-choice"
                      />
                      <div
                        class="dz-image"
                        id="favicon-img-logo"
                        style="height: 34px;width: 68px;border: 1px solid #ccc;margin-left: 5px;margin-right: 5px;position: relative;flex: 0 0 10%;"
                      >
                        <v-lazy-image
                          :src="value.image.dataURL"
                          :id="'15 '+index"
                          :data-score-value="scoreValues[index] ? scoreValues[index] : null"
                        ></v-lazy-image>
                        <!-- <img
                          :src="value.image.dataURL"
                          :id="'15 '+index"
                          :data-score-value="scoreValues[index] ? scoreValues[index] : null"
                          style="max-height: 100%;max-width: 100%;width: auto;height: auto;position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;"
                        >-->
                      </div>
                      <vue-dropzone
                        :id="'dropzoneReplaceImage_' + index"
                        :useCustomSlot="true"
                        :includeStyling="false"
                        :options="dropzoneOptionsForReplaceImage"
                        ref="replaceImageRef"
                        @vdropzone-file-added="(file) => onAdded(file, index)"
                      >
                        <a
                          href.prevent
                          title="Change Image"
                          class="delete_icon"
                          style="flex: 0 0 10%"
                        >
                          <i class="fa fa-repeat" aria-hidden="true"></i>
                        </a>
                      </vue-dropzone>
                      <a
                        href.prevent
                        class="delete_icon"
                        @click.prevent="deleteMultipleChoiceImage(index, value)"
                        style="flex: 0 0 10%;"
                      >
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                      </a>
                      <div class="dz-error-message">
                        <span data-dz-errormessage></span>
                      </div>
                    </div>
                  </draggable>
                  <draggable
                    :options="{handle:'.handle'}"
                    class="answer_choies previews"
                    style="display: block;"
                  ></draggable>
                  <vue-dropzone
                    v-if="questionData.imageArray.length <= 20"
                    :useCustomSlot="true"
                    :includeStyling="false"
                    class="drop-box"
                    id="dropzone"
                    @vdropzone-file-added="onAdded"
                    @vdropzone-error="onError"
                    :options="dropzoneOptionsForMultipleChoise"
                    ref="multipleChoiceImageRef"
                  >
                    <div class="dropzone-text">Drag and drop images here, or click to upload</div>
                  </vue-dropzone>

                  <span
                    class="error"
                    v-if="errors.has('multipleChoiseImageArray')"
                  >{{ errors.first('multipleChoiseImageArray') }}</span>
                  <span class="error" v-if="twoMBvalidation">{{twoMBvalidation}} </span>
                </div>
              </div>
            </div>
          </div>
          <!-- For image control -->
          <div
            v-if="controlData[activeType]['validation_details_ids'][0]['in_question_type_id']== vueQueTypeConfig.TYPE_IMAGE ? dropzoneOptionsForMultipleChoise.previewTemplate = templateForImage() : 0"
          >
            <div class="edit_box">
              <h4 class="edit_head">Image</h4>
              <!-- <div class="img_preview" v-for="i in 4">
                <img :src="img" />
              </div>-->
              <!-- <img :src="designall.logo" /> -->
              <div class="add_image">
                <div v-if="questionData.imageArray.length > 0">
                  <div
                    style="display: inline-flex; margin-bottom: 5px;"
                    v-for="(value, index) in questionData.imageArray"
                    :key="index"
                  >
                    <div class="image-container">
                      <v-lazy-image class="image-thumbnail" alt="1" :src="value.image.dataURL"></v-lazy-image>
                      <!-- <img class="image-thumbnail" alt="1" :src="value.image.dataURL"> -->
                      <span
                        @click.prevent="deleteImage(index, value)"
                        class="fa fa-close delete-image delete-existing-image"
                      ></span>
                    </div>
                  </div>
                </div>
                <div class="answer_choies previews" style="display: block;"></div>
                <vue-dropzone
                  v-validate.initial="'required|minOneImage'"
                  data-vv-as="above"
                  name="imageQuestionType"
                  v-model="questionData.imageArray"
                  :useCustomSlot="true"
                  :includeStyling="false"
                  class="drop-box"
                  id="dropzone_img"
                  :options="dropzoneOptionsForMultipleChoise"
                  @vdropzone-error="onError"
                  @vdropzone-file-added="onAdded"
                  ref="imageControlDropzone"
                >
                  <div class="dropzone-text">Drag and drop images here, or click to upload</div>
                </vue-dropzone>
                <span
                  class="error"
                  v-if="errors.has('imageQuestionType')"
                >{{ errors.first('imageQuestionType') }}</span>
                <span class="error" v-if="twoMBvalidation">{{twoMBvalidation}} </span>
              </div>
            </div>
          </div>

          <div
            :class="[vueQueValidationConfig.VALIDATION_MIN_CHAR, vueQueValidationConfig.VALIDATION_MAX_CHAR, vueQueValidationConfig.VALIDATION_MIN_NUM,vueQueValidationConfig.VALIDATION_MAX_NUM,
            vueQueValidationConfig.VALIDATION_MIN_TIME,
            vueQueValidationConfig.VALIDATION_MAX_TIME,
            vueQueValidationConfig.VALIDATION_MIN_DATE,
            vueQueValidationConfig.VALIDATION_MAX_DATE,
            ].includes(childValidations['details'][0]['in_validation_id'])  ? 'question_type_select edit_box active min-max-textbox' : [vueQueValidationConfig.VALIDATION_MANDATORY_QUE, vueQueValidationConfig.VALIDATION_ALLOW_OTHER_ANS, vueQueValidationConfig.VALIDATION_ALLOW_DECIMAL_NUM,
            vueQueValidationConfig.VALIDATION_ALLOW_MORE_THAN_ONE_ANS,vueQueValidationConfig.VALIDATION_SHOW_ANS_LABEL,vueQueValidationConfig.VALIDATION_EMAIL_SURVEY_RESULTS,vueQueValidationConfig.VALIDATION_SHOW_TITLE,vueQueValidationConfig.VALIDATION_ACCESS_TO_GALLERY,
            vueQueValidationConfig.VALIDATION_ACCESS_TO_MEDIA_GALLERY,vueQueValidationConfig.VALIDATION_DRAW_ON_PHOTO,vueQueValidationConfig.VALIDATION_ADDRESS_QUE].includes(childValidations['details'][0]['in_validation_id'])  ? (all.in_status === vueCommonConfig.SURVEY_PUBLISHED && ([vueQueValidationConfig.VALIDATION_ALLOW_OTHER_ANS].includes(childValidations['details'][0]['in_validation_id']) || (vueQueValidationConfig.VALIDATION_ALLOW_MORE_THAN_ONE_ANS == childValidations['details'][0]['in_validation_id'] && getQuestionAll.in_audit == 1))) ? 'disabledbutton question_type_select edit_box active radio-box other-options' : 'question_type_select edit_box active radio-box other-options' : all.in_status === vueCommonConfig.SURVEY_PUBLISHED && [vueQueValidationConfig.VALIDATION_FIRST_CHOICE,vueQueValidationConfig.VALIDATION_SECOND_CHOICE,vueQueValidationConfig.VALIDATION_TERMS_AND_CONDITIONS,vueQueValidationConfig.VALIDATION_MULTIPLE_SINGLE_ANS,vueQueValidationConfig.VALIDATION_FACE_RATING,vueQueValidationConfig.VALIDATION_STAR_RATING,vueQueValidationConfig.VALIDATION_TEXT,vueQueValidationConfig.VALIDATION_ALLOWED_CURRENCY_CHAR,vueQueValidationConfig.VALIDATION_DATE_FORMAT].includes(childValidations['details'][0]['in_validation_id']) ? 'disabledbutton question_type_select edit_box active' : 'question_type_select edit_box active'"
            v-for="(childValidations,index1) in controlData[activeType]['validation_details_ids']"
            v-if="!(([vueQueValidationConfig.VALIDATION_SINGLE_LINE,vueQueValidationConfig.VALIDATION_PARAGRAPH,vueQueValidationConfig.VALIDATION_SERIAL_NUM,vueQueValidationConfig.VALIDATION_TIMEOUT,
          vueQueValidationConfig.VALIDATION_BUTTON].includes(childValidations['details'][0]['in_validation_id']) && (childValidations['in_question_type_id'] == vueQueTypeConfig.TYPE_INPUT || childValidations['in_question_type_id'] == vueQueTypeConfig.TYPE_START_SCREEN_TEXT || childValidations['in_question_type_id'] == vueQueTypeConfig.TYPE_END_SCREEN_TEXT)) || ([vueQueValidationConfig.VALIDATION_IMAGE].includes(childValidations['details'][0]['in_validation_id']) && childValidations['in_question_type_id'] == vueQueTypeConfig.TYPE_IMAGE) || childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_SERVICE_IDS)"
            :key="index1"
          >
            <div
              v-if="childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_TEXT"
            >
              
              <h4 class="edit_head mx-0 mb-2">Answers<span class="excel_btn pt-0">
                <a class="btn btn-sm btn-light rounded py-0" @click.prevent="questionUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : downloadExcel()" href="#" title="Download Excel File"><i class="fa fa-download px-1" aria-hidden="true" ></i></a>
                <a class="btn btn-sm btn-light rounded py-0 " @click.prevent=" questionUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : openModal()" href="#" title="Upload Excel File"><i class="fa fa-upload px-1" aria-hidden="true" ></i></a>
                </span></h4>
                <div>
              </div>

              <draggable
                v-validate.initial="'minTwoText|uniqueAns'"
                name="multipleChoiseTextArray"
                v-model="ansCount"
                :options="{handle:'.handle'}"
                @sort="onSort"
              >
                <div
                  class="answer_choies select-ans-width"
                  v-for="(i,index) in ansCount"
                  :key="index"
                >
                  <a href="javascript:void(0);" class="delete_icon handle" style="flex: 0 0 10%">
                    <i class="fa fa-arrows" aria-hidden="true"></i>
                  </a>
                  <input
                    @change="inputChanged"
                    :id="childValidations['details'][0]['in_validation_id']+' '+index"
                    v-validate.initial="'required'"
                    :name="childValidations['details'][0]['in_validation_id']+' '+index"
                    data-vv-as="above"
                    :data-score-value="scoreValues[index] ? scoreValues[index] : null"
                    v-model="ansCount[index]"
                    type="text"
                    class="form-control"
                  />
                  <a
                    href="#"
                    class="delete_icon"
                    v-if="ansCount.length > 2 && ansCount[0]!='' && ansCount[1]!='' && ansCount[2]!=''"
                  >
                    <i
                      @click.prevent="deleteMultipleChoiceAnswer(index)"
                      class="fa fa-trash-o"
                      aria-hidden="true"
                    ></i>
                  </a>
                  <span
                    class="error"
                    v-if="errors.has(''+childValidations['details'][0]['in_validation_id']+' '+index)"
                  >{{ errors.first(''+childValidations['details'][0]['in_validation_id']+' '+index) }}</span>
                </div>
              </draggable>

              <span
                v-if="errors.has('multipleChoiseTextArray')"
                class="error"
              >{{ errors.first('multipleChoiseTextArray')}}</span>
              <div class="answer_choies">
                <a @click.prevent="incMultipleChoiceAnsCount" href="#" class="add_more_fild">
                  <i class="fa fa-plus" aria-hidden="true"></i> add more answers
                </a>
              </div>
            </div>
            <div
              class="edit_box answer_btn"
              v-if="childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_MANDATORY_QUE || childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_ALLOW_OTHER_ANS || childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_ALLOW_MORE_THAN_ONE_ANS || childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_SHOW_ANS_LABEL || childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_EMAIL_SURVEY_RESULTS || childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_ALLOW_DECIMAL_NUM || childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_SHOW_TITLE ||
              childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_ACCESS_TO_GALLERY || childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_DRAW_ON_PHOTO ||
              childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_ADDRESS_QUE || childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_ACCESS_TO_MEDIA_GALLERY"
            >
              <!-- <h4 class="edit_head" v-if="optNotShownBefore === true ? 1 : 0">Options</h4> -->
              <!-- <h4 class="edit_head other-options-head" v-if="childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_MANDATORY_QUE || (childValidations['in_question_type_id'] == vueQueTypeConfig.TYPE_IMAGE && childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_SHOW_TITLE)">Controls</h4> -->
              <label class="switch">
                <input
                  v-if="childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_ALLOW_OTHER_ANS"
                  v-validate.initial="childValidations['in_question_type_id'] == vueQueTypeConfig.TYPE_LIST ? 'minlines:'+questionData.validationDetails[6] : ''"
                  data-vv-as="checkbox"
                  name="6"
                  :key="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                  :id="vueQueValidationConfig.VALIDATION_ALLOW_OTHER_ANS +' others'"
                  @change="inputChanged"
                  v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                  type="checkbox"
                  :data-score-value="scoreOthers"
                />
                <input
                  v-else
                  :key="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                  @change="inputChanged"
                  v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                  type="checkbox"
                />
                <span class="slider round"></span>
              </label>
              <p>{{childValidations['details'][0]['st_validation_name']}}</p>
            </div>
            <!-- For list & terms and conditions  -->
            <div
              v-if="(childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_SINGLE_LINE ||childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_TERMS_AND_CONDITIONS) && childValidations['in_question_type_id'] != vueQueTypeConfig.TYPE_INPUT"
            >
              <h4
                class="edit_head"
                v-if="childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_SINGLE_LINE"
              >Answers(one per line)
              <span class="excel_btn pt-0">
                <a
                :class="all.in_status === vueCommonConfig.SURVEY_PUBLISHED ? 'disabledbutton btn btn-sm btn-light rounded py-0' : 'btn btn-sm btn-light rounded py-0'"
                @click.prevent="questionUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : downloadExcel()" href="#" title="Download Excel File"><i class="fa fa-download px-1" aria-hidden="true" ></i></a>
                <a
                :class="all.in_status === vueCommonConfig.SURVEY_PUBLISHED ? 'disabledbutton btn btn-sm btn-light rounded py-0' : 'btn btn-sm btn-light rounded py-0'"
                 @click.prevent=" questionUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : openModal()" href="#" title="Upload Excel File"><i class="fa fa-upload px-1" aria-hidden="true" ></i></a>
                </span>
              </h4>
              <h4 class="edit_head" v-else>{{childValidations['details'][0]['st_validation_name']}}</h4>
              <textarea
                @change="inputChanged"
                v-validate.initial="childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_SINGLE_LINE ? 'required|emptyline|minlines' : 'required'"
                :name="childValidations['details'][0]['in_validation_id']"
                data-vv-as="above"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                :class="all.in_status === vueCommonConfig.SURVEY_PUBLISHED || (skipLogicQids && skipLogicQids.has(questionData.in_question_master_id)) ? 'allowed-scroll form-control' : 'form-control'"
                rows="9"
                style="resize:both"
                :readonly="all.in_status === vueCommonConfig.SURVEY_PUBLISHED || (skipLogicQids && skipLogicQids.has(questionData.in_question_master_id))"
                :key="childValidations['details'][0]['in_validation_id']"
              ></textarea>
              <span
                class="error"
                v-if="errors.has(''+childValidations['details'][0]['in_validation_id'])"
              >{{ errors.first(''+childValidations['details'][0]['in_validation_id']) }}</span>
            </div>
            <!-- For two choices other options input box -->
            <div
              v-if="childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_FIRST_CHOICE || childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_SECOND_CHOICE "
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <input
                @change="inputChanged"
                v-validate.initial="childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_FIRST_CHOICE ?{required:1, is_not: questionData.validationDetails[vueQueValidationConfig.VALIDATION_SECOND_CHOICE] }:{required:1, is_not: questionData.validationDetails[vueQueValidationConfig.VALIDATION_FIRST_CHOICE] }"
                :name="childValidations['details'][0]['in_validation_id']"
                data-vv-as="above"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                type="text"
                class="form-control"
              />
              <span
                class="error"
                v-if="errors.has(''+childValidations['details'][0]['in_validation_id'])"
              >{{ errors.first(''+childValidations['details'][0]['in_validation_id']) }}</span>
            </div>
            <div
              v-if="childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_SUBTITLE"
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <textarea
                @change="inputChanged"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                rows="3"
                class="form-control"
              ></textarea>
            </div>
            <!-- for terms & conditions yes no options  -->
          
            <div
              v-if="childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_MULTIPLE_SINGLE_ANS"
            >
              <h4 class="edit_head">Answers</h4>
              <div class="answer_choies width-100" v-for="(i,index) in ansCount" :key="index">
                <input
                  @change="inputChanged"
                  v-validate.initial="'required'"
                  :name="childValidations['details'][0]['in_validation_id']+' '+index"
                  data-vv-as="above"
                  v-model="ansCount[index]"
                  type="text"
                  class="form-control"
                />
                <a
                  href="#"
                  class="delete_icon"
                  v-if="ansCount.length > 1  && ansCount[0]!='' && ansCount[1]!=''"
                >
                  <i @click.prevent="deleteAnswer(index)" class="fa fa-trash-o" aria-hidden="true"></i>
                </a>
                <span
                  class="error"
                  v-if="errors.has(''+childValidations['details'][0]['in_validation_id']+' '+index)"
                >{{ errors.first(''+childValidations['details'][0]['in_validation_id']+' '+index) }}</span>
              </div>
              <div class="answer_choies">
                <a @click.prevent="incAnsCount" href="#" class="add_more_fild">
                  <i class="fa fa-plus" aria-hidden="true"></i> add more answers
                </a>
              </div>
            </div>
            <!-- Dynamic Question Settings (Contract + Services + Objects) -->
            <div
              v-if="childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_CONTRACT_ID"
            >
              <DynamicQuestionSettings
                ref="dynamicSettings"
                :questionMasterId="questionData.in_question_master_id"
                :surveyId="$route.params.id"
                :isPublished="all.in_status === vueCommonConfig.SURVEY_PUBLISHED"
                :sessionData="dynamicConfigSessionData"
                @configChanged="inputChanged"
              />
            </div>
            <!-- For min & max character -->
            <div
              class="topPicker"
              v-if="childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_MIN_CHAR"
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <!-- v-validate.initial="questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_CHAR] ? 'numeric|max_value:'+questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_CHAR] : 'numeric'" -->
              <input
                key="2"
                @change="inputChanged"
                @input="questionData.validationDetails[''+vueQueValidationConfig.VALIDATION_MIN_NUM] = questionData.validationDetails[''+vueQueValidationConfig.VALIDATION_MIN_CHAR]"
                v-validate.initial="questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_CHAR] ? 'numeric|max_value:'+questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_CHAR] : 'numeric'"
                name="2"
                data-vv-as="Min Value"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                type="number"
                min="1"
                class="form-control"
              />
              <span class="error" v-if="errors.has('2')">{{ errors.first('2') }}</span>
            </div>
            <div
              class="bottomPicker"
              v-if="childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_MAX_CHAR"
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <input
                key="3"
                @change="inputChanged"
                @input="questionData.validationDetails[''+vueQueValidationConfig.VALIDATION_MAX_NUM] = questionData.validationDetails[''+vueQueValidationConfig.VALIDATION_MAX_CHAR]"
                v-validate.initial="questionData.validationDetails[vueQueValidationConfig.VALIDATION_MIN_CHAR] ? 'numeric|min_value:'+questionData.validationDetails[vueQueValidationConfig.VALIDATION_MIN_CHAR] : 'numeric'"
                name="3"
                data-vv-as="Max Value"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                type="number"
                min="1"
                class="form-control"
              />
              <span class="error" v-if="errors.has('3')">{{ errors.first('3') }}</span>
            </div>
            <!-- For min & max number -->
            <div
              class="topPicker"
              v-if="childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_MIN_NUM"
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <input
                key="4"
                @change="inputChanged"
                @input="questionData.validationDetails[''+vueQueValidationConfig.VALIDATION_MIN_CHAR] = questionData.validationDetails[''+vueQueValidationConfig.VALIDATION_MIN_NUM]"
                v-validate.initial="questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_NUM] ? questionData.validationDetails[vueQueValidationConfig.VALIDATION_ALLOW_DECIMAL_NUM] ? 'decimal:2|max_value:'+questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_NUM] : {regex: /^-?[0-9]\d*?$/, max_value: questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_NUM]} : questionData.validationDetails[vueQueValidationConfig.VALIDATION_ALLOW_DECIMAL_NUM] ? 'decimal:2' : {regex: /^-?[0-9]\d*?$/}"
                :name="childValidations['details'][0]['in_validation_id']"
                data-vv-as="Min Number"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                type="number"
                class="form-control"
              />
              <span class="error" v-if="errors.has('4')">{{ errors.first('4') }}</span>
            </div>
            <div
              class="bottomPicker"
              v-if="childValidations['details'][0]['in_validation_id']==vueQueValidationConfig.VALIDATION_MAX_NUM"
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <input
                key="5"
                @change="inputChanged"
                @input="questionData.validationDetails[''+vueQueValidationConfig.VALIDATION_MAX_CHAR] = questionData.validationDetails[''+vueQueValidationConfig.VALIDATION_MAX_NUM]"
                v-validate.initial="questionData.validationDetails[vueQueValidationConfig.VALIDATION_MIN_NUM] ? questionData.validationDetails[vueQueValidationConfig.VALIDATION_ALLOW_DECIMAL_NUM] ? 'decimal:2|min_value:'+questionData.validationDetails[vueQueValidationConfig.VALIDATION_MIN_NUM] : {regex: /^-?[0-9]\d*?$/, min_value: questionData.validationDetails[vueQueValidationConfig.VALIDATION_MIN_NUM]} : questionData.validationDetails[vueQueValidationConfig.VALIDATION_ALLOW_DECIMAL_NUM] ? 'decimal:2' : {regex: /^-?[0-9]\d*?$/}"
                :name="childValidations['details'][0]['in_validation_id']"
                data-vv-as="Max Number"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                type="number"
                class="form-control"
              />
              <span class="error" v-if="errors.has('5')">{{ errors.first('5') }}</span>
            </div>
            <!--For Allowed currency/telephone characters -->
            <div
              v-if="childValidations['details'][0]['in_validation_id']==vueQueValidationConfig.VALIDATION_ALLOWED_TELEPHONE_CHAR || childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_ALLOWED_CURRENCY_CHAR"
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <div
                class="ck-button"
                v-for="(allowChar, index) in childValidations['details'][0]['st_validation_value'].split('sep')"
                :key="index"
              >
                <label class="ck-label">
                  <input
                    v-if="childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_ALLOWED_CURRENCY_CHAR"
                    v-validate.initial="'maxOneChecked:'+questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']+ ' allowChar '+ allowChar]"
                    name="27"
                    hidden
                    data-vv-rules="maxOneChecked:checked"
                    data-vv-as="checkbox"
                    @change="inputChanged"
                    onclick="this.checked=true;"
                    v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']+ ' allowChar '+ allowChar ]"
                    type="checkbox"
                  />
                  <input
                    v-else
                    name="27"
                    hidden
                    @change="inputChanged"
                    v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']+ ' allowChar '+ allowChar ]"
                    type="checkbox"
                  />
                  <span class="ck-span">{{allowChar}}</span>
                </label>
              </div>
              <div class="clearfix"></div>
              <span class="error" v-if="errors.has('27')">{{ errors.first('27') }}</span>
            </div>
            <!-- For date format option -->
            
            <div class="date-align"
              v-if="childValidations['details'][0]['in_validation_id']==vueQueValidationConfig.VALIDATION_DATE_FORMAT"
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <multi-select
                name="dateFormat"
                @input="inputChanged()"
                deselect-label="Can't remove this value"
                :allow-empty="false"
                open-direction="bottom"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                :options="['YYYY-MM-DD','YY-MM-DD','DD-MM-YY','DD-MM-YYYY','MM-DD-YY','MM-DD-YYYY']"
              ></multi-select>
            </div>
            <!--For min & max date -->
            <!-- @onkeypress.native="restrictAlphabets($event)" -->
            <div
              class="topPicker"
              v-if="childValidations['details'][0]['in_validation_id'] == vueQueValidationConfig.VALIDATION_MIN_DATE"
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <vue-date-picker
                ref="datepicker1"
                @focus="showPopup"
                @change="inputChanged()"
                :not-after="questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_DATE]"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                :format="questionData.validationDetails[vueQueValidationConfig.VALIDATION_DATE_FORMAT] ? questionData.validationDetails[vueQueValidationConfig.VALIDATION_DATE_FORMAT] : 'DD-MM-YYYY'"
                :first-day-of-week="1"
                :lang="lang"
                :append-to-body="true"
              ></vue-date-picker>
              <!-- <date-picker
                @dp-change="inputChanged()"
                :config="questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_DATE] ? {'maxDate': moment(questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_DATE], 'DD-MM-YYYY'),'format': questionData.validationDetails[vueQueValidationConfig.VALIDATION_DATE_FORMAT] ? questionData.validationDetails[vueQueValidationConfig.VALIDATION_DATE_FORMAT] : 'DD-MM-YYYY',useCurrent: false,'showClear': true,'showClose': true,'widgetPositioning': {
            vertical: 'auto',
            horizontal: 'left'
          }} : {'format': questionData.validationDetails[vueQueValidationConfig.VALIDATION_DATE_FORMAT] ? questionData.validationDetails[vueQueValidationConfig.VALIDATION_DATE_FORMAT] : 'DD-MM-YYYY','showClear': true,useCurrent: false,'showClose': true,'widgetPositioning': {
            vertical: 'auto',
            horizontal: 'left'
          }}"
                name="date1"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
              ></date-picker>-->
            </div>
            
            <div
              class="bottomPicker"
              v-if="childValidations['details'][0]['in_validation_id']==vueQueValidationConfig.VALIDATION_MAX_DATE"
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <vue-date-picker
                ref="datepicker2"
                @focus="showPopup"
                @change="inputChanged()"
                :not-before="questionData.validationDetails[vueQueValidationConfig.VALIDATION_MIN_DATE]"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                :format="questionData.validationDetails[vueQueValidationConfig.VALIDATION_DATE_FORMAT] ? questionData.validationDetails[vueQueValidationConfig.VALIDATION_DATE_FORMAT] : 'DD-MM-YYYY'"
                :first-day-of-week="1"
                :lang="lang"
                :append-to-body="true"
              ></vue-date-picker>
              <!-- <date-picker
                @dp-change="inputChanged()"
                :config="questionData.validationDetails[vueQueValidationConfig.VALIDATION_MIN_DATE] ? {'minDate':moment(questionData.validationDetails[vueQueValidationConfig.VALIDATION_MIN_DATE], 'DD-MM-YYYY'),'format': questionData.validationDetails[vueQueValidationConfig.VALIDATION_DATE_FORMAT] ? questionData.validationDetails[vueQueValidationConfig.VALIDATION_DATE_FORMAT] : 'DD-MM-YYYY',useCurrent: false,'showClear': true,'showClose': true,'widgetPositioning': {
            vertical: 'auto',
            horizontal: 'left'
          }} : {'format': questionData.validationDetails[vueQueValidationConfig.VALIDATION_DATE_FORMAT] ? questionData.validationDetails[vueQueValidationConfig.VALIDATION_DATE_FORMAT] : 'DD-MM-YYYY',useCurrent: false,'showClear': true,'showClose': true,'widgetPositioning': {
            vertical: 'auto',
            horizontal: 'left'
          }}"
                name="date2"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
              ></date-picker>-->
            </div>
            <!-- For min max time -->
            
            <div
              class="topPicker"
              v-if="childValidations['details'][0]['in_validation_id']==vueQueValidationConfig.VALIDATION_MIN_TIME"
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <!-- 'maxDate':questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_TIME], -->
              <!-- <date-picker
                class="min-time"
                v-validate="'checkTime'"
                data-vv-as="above"
                name="checkMinMaxTime"
                autocomplete="off"
                @input="inputChanged()"
                :config="maxTimeOptions"
                key="time1"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
              ></date-picker> -->
              <v-app>
                <v-dialog
                  ref="dialog_mintime"
                  v-model="mintimeDialog"
                  :return-value.sync="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                  persistent
                  width="330px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      solo
                      single-line
                      key="time1"
                      v-model="mintimeTextModel"
                      @click:clear="clearTimepickerValue(childValidations['details'][0]['in_validation_id'])"
                      :class="mintimeTextModel ? 'time-picker-control' : 'padding-0 time-picker-control'"
                      v-validate="'checkTime'"
                      name="checkMinMaxTime"
                      v-bind="attrs"
                      v-on="on"
                      data-vv-as="above"
                      readonly
                      :clearable="mintimeTextModel ? true : false"
                      hide-details="auto"
                      flat
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    key="timepicker_mintime"
                    v-if="mintimeDialog"
                    v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                    :format="activeType == 0 ? 'ampm' : '24hr'"
                    :max="questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_TIME] ? activeType == 0 ? moment(questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_TIME], 'hh:mm:ss A').format('HH:mm:ss') : questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_TIME]
                      : undefined"
                    use-seconds
                    full-width
                    ampm-in-title
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="mintimeDialog = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="setTimePickerValue('dialog_mintime', childValidations['details'][0]['in_validation_id'])">
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-app>
            </div>
            <div
              class="bottomPicker"
              v-if="childValidations['details'][0]['in_validation_id']==vueQueValidationConfig.VALIDATION_MAX_TIME"
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <!-- <date-picker
                class="max-time"
                v-validate="'checkTime'"
                data-vv-as="above"
                name="checkMinMaxTime"
                autocomplete="off"
                @input="inputChanged()"
                :config="minTimeOptions"
                key="time2"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
              ></date-picker> -->
              <v-app>
                <v-dialog
                  ref="dialog_maxtime"
                  v-model="maxtimeDialog"
                  :return-value.sync="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                  persistent
                  width="330px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      solo
                      single-line
                      key="time2"
                      v-model="maxtimeTextModel"
                      @click:clear="clearTimepickerValue(childValidations['details'][0]['in_validation_id'])"
                      :class="maxtimeTextModel ? 'time-picker-control' : 'padding-0 time-picker-control'"
                      v-validate="'checkTime'"
                      name="checkMinMaxTime"
                      v-bind="attrs"
                      v-on="on"
                      data-vv-as="above"
                      readonly
                      :clearable="maxtimeTextModel ? true : false"
                      hide-details="auto"
                      flat
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    key="timepicker_maxtime"
                    v-if="maxtimeDialog"
                    v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                    :format="activeType == 0 ? 'ampm' : '24hr'"
                    :min="questionData.validationDetails[vueQueValidationConfig.VALIDATION_MIN_TIME] ? activeType == 0 ? moment(questionData.validationDetails[vueQueValidationConfig.VALIDATION_MIN_TIME], 'hh:mm:ss A').format('HH:mm:ss') : questionData.validationDetails[vueQueValidationConfig.VALIDATION_MIN_TIME]
                      : undefined"
                    use-seconds
                    full-width
                    ampm-in-title
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="maxtimeDialog = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="setTimePickerValue('dialog_maxtime', childValidations['details'][0]['in_validation_id'])">
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-app>
              <span
                class="error"
                v-if="errors.has('checkMinMaxTime')"
              >{{ errors.first('checkMinMaxTime') }}</span>
            </div>
            <!-- For image flow -->
            
            <div
              v-if="childValidations['details'][0]['in_validation_id']==vueQueValidationConfig.VALIDATION_FLOW "
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <ul class="question_select marginB0">
                <li>
                  <input
                    @change="inputChanged"
                    v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                    value="0"
                    name="flow_selected"
                    type="radio"
                    id="img_one_row"
                  />
                  <label for="img_one_row">In One Row</label>
                </li>
                <li>
                  <input
                    @change="inputChanged"
                    v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                    value="1"
                    name="flow_selected"
                    type="radio"
                    id="img_one_column"
                  />
                  <label for="img_one_column">In One Column</label>
                </li>
              </ul>
            </div>
            <!-- For camera -->
            
            <div
              v-if="childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_CAMERA "
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <ul class="question_select selection-mb-0">
                <li>
                  <input
                    @change="inputChanged"
                    v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                    value="1"
                    name="camera_selected"
                    type="radio"
                    id="photo_rear"
                  />
                  <label for="photo_rear">Rear</label>
                </li>
                <li>
                  <input
                    @change="inputChanged"
                    v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                    value="0"
                    name="camera_selected"
                    type="radio"
                    id="photo_front"
                  />
                  <label for="photo_front">Front</label>
                </li>
              </ul>
            </div>
            <!-- For star rating-->
            <div
              v-if="childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_STAR_RATING "
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <span class="rating">
                <label v-for="index in 10" :key="index">
                  <input
                    v-validate.initial="'required|min_value:2'"
                    :name="childValidations['details'][0]['in_validation_id']"
                    data-vv-as="above"
                    @change="inputChanged"
                    v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                    type="radio"
                    :value="index"
                  />
                  <span class="icon" v-for="i in index" :key="i">★</span>
                </label>
              </span>
              <span class="error" v-if="errors.has('38')">{{ errors.first('38') }}</span>
            </div>
            <!-- For face rating -->
            <div
              v-if="childValidations['details'][0]['in_validation_id']== vueQueValidationConfig.VALIDATION_FACE_RATING"
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <div
                class="ck-button"
                v-for="(allowChar, index) in childValidations['details'][0]['st_validation_value'].split('sep')"
                :key="index"
              >
                <label class="ck-label">
                  <input
                    v-validate.initial="'twoChecked:'+questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']+ ' allowChar '+ allowChar]"
                    hidden
                    name="39"
                    class="hidden"
                    data-vv-rules="twoChecked:checked"
                    data-vv-as="checkbox"
                    @change="inputChanged"
                    v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']+ ' allowChar '+ allowChar ]"
                    type="checkbox"
                  />
                  <span class="ck-span">
                    <i :class="smileyClass[allowChar]"></i>
                  </span>
                </label>
              </div>
              <div class="clearfix"></div>
              <span class="error" v-if="errors.has('39')">{{ errors.first('39') }}</span>
            </div>
            <!-- For start screen title -->
            <div
              v-if="childValidations['details'][0]['in_validation_id'] === vueQueValidationConfig.VALIDATION_TITLE "
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <input
                @change="inputChanged"
                v-validate.initial="childValidations['in_question_type_id'] === vueQueTypeConfig.TYPE_END_SCREEN_TEXT ? 'required' : ''"
                :name="childValidations['details'][0]['in_validation_id']"
                data-vv-as="above"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                type="text"
                class="form-control"
              />
              <span
                class="error"
                v-if="errors.has(''+childValidations['details'][0]['in_validation_id'])"
              >{{ errors.first(''+childValidations['details'][0]['in_validation_id']) }}</span>
            </div>
            <!-- For image in start and end control -->
            <div
              v-if="(controlData[activeType]['validation_details_ids'][0]['in_question_type_id']== vueQueTypeConfig.TYPE_START_SCREEN_TEXT || controlData[activeType]['validation_details_ids'][0]['in_question_type_id']== vueQueTypeConfig.TYPE_END_SCREEN_TEXT) && childValidations['details'][0]['in_validation_id'] === vueQueValidationConfig.VALIDATION_IMAGE ? dropzoneOptionsForStartScreen.previewTemplate = templateForImage() : 0"
            >
              <h4 class="edit_head">Image</h4>
              <!-- <div class="img_preview" v-for="i in 4">
                <img :src="img" />
              </div>-->
              <!-- <img :src="designall.logo" /> -->
              <div class="add_image marginB15 align-img">
                <div v-if="questionData.imageArray.length > 0">
                  <div
                    style="display: inline-flex; margin-bottom: 5px;"
                    v-for="(value, index) in questionData.imageArray"
                    :key="index"
                  >
                    <div class="image-container">
                      <v-lazy-image
                        @load="imgloaded"
                        class="image-thumbnail"
                        alt="1"
                        :src="value.image.dataURL"
                      ></v-lazy-image>
                      <!-- <img
                        @load="imgloaded"
                        class="image-thumbnail"
                        alt="1"
                        :src="value.image.dataURL"
                      >-->
                      <span
                        @click.prevent="deleteImage(index, value)"
                        class="fa fa-close delete-image delete-existing-image"
                      ></span>
                    </div>
                  </div>
                  <vue-dropzone
                    id="dropzoneReplaceStartImage"
                    :useCustomSlot="true"
                    :includeStyling="false"
                    :options="dropzoneOptionsForReplaceImage"
                    ref="replaceStartImageRef"
                    @vdropzone-file-added="(file) => onAdded(file, 0)"
                  >
                    <a href.prevent title="Change Image" class="delete_icon" style="flex: 0 0 10%">
                      <i class="fa fa-repeat" aria-hidden="true"></i>
                    </a>
                  </vue-dropzone>
                </div>
                <div class="answer_choies previews displayNone"></div>
                <vue-dropzone
                  data-vv-as="above"
                  name="imageScreenType"
                  v-model="questionData.imageArray"
                  :useCustomSlot="true"
                  :includeStyling="false"
                  :class="(questionData.imageArray.length <= 0) ? 'drop-box' : 'displayNone'"
                  id="dropzone_img"
                  :options="dropzoneOptionsForStartScreen"
                  @vdropzone-error="onError"
                  @vdropzone-file-added="onAdded"
                  ref="imageControlDropzone"
                >
                  <div class="dropzone-text">Drag and drop images here, or click to upload</div>
                </vue-dropzone>
              </div>
            </div>
            <!-- For start screen button text -->
            <div
              v-if="childValidations['details'][0]['in_validation_id'] === vueQueValidationConfig.VALIDATION_BUTTON_TEXT "
            >
              <h4 class="edit_head">{{childValidations['details'][0]['st_validation_name']}}</h4>
              <input
                @change="inputChanged"
                v-validate="'required'"
                :name="childValidations['details'][0]['in_validation_id']"
                data-vv-as="above"
                key="45"
                v-model="questionData.validationDetails[''+childValidations['details'][0]['in_validation_id']]"
                type="text"
                class="form-control"
              />
              <span
                class="error"
                v-if="errors.has(''+childValidations['details'][0]['in_validation_id'])"
              >{{ errors.first(''+childValidations['details'][0]['in_validation_id']) }}</span>
            </div>
          </div>
        </div>
        <!-- For child validations radio button display -->
        <div
          class="edit_box"
          v-if="controlData[activeType]['validation_details_ids'][0]['in_question_type_id']== vueQueTypeConfig.TYPE_INPUT || controlData[activeType]['validation_details_ids'][0]['in_question_type_id']== vueQueTypeConfig.TYPE_END_SCREEN_TEXT"
        >
          <h4
            class="edit_head"
            v-show="inIsParent[0]['in_question_validation_id'] == 1 && inIsParent[0]['in_is_parent']"
            v-if="questionData.validationDetails.childVid == 0 ? setDefaultActiveChild(inIsParent[0]['details'][0]['in_validation_id'])  : 1 "
          >Options</h4>
          <h4
            class="edit_head"
            v-show="(inIsParent[0]['in_question_validation_id'] == 89 || inIsParent[0]['in_question_validation_id'] == 90) && inIsParent[0]['in_is_parent']"
            v-if="questionData.validationDetails.childVid == 0 ? setDefaultActiveChild(inIsParent[0]['details'][0]['in_validation_id'])  : 1 "
          >Ending Scenerio</h4>
          <ul class="question_select" v-if="inIsParent.length > 0">
            <!-- disable input class
            1. In single line and paragraph => Serial number disabled
            2. In Serial number => single line and paragraph disabled -->
            <li v-for="(control,index) in inIsParent" :key="index" :class="{ disabledbutton: (all.in_status === vueCommonConfig.SURVEY_PUBLISHED && (((activeChildTab == 0 || activeChildTab == 1) && index == 2) || ((index == 0 || index == 1) && activeChildTab == 2))) }">
              <input
                type="radio"
                :id="'qtypechild_'+index"
                name="question_selected"
                v-bind:checked="index == activeChildTab ? '1':''"
                @input="updateChildTab($event,control['details'][0]['in_validation_id'])"
              />
              <label :for="'qtypechild_'+index">{{control['details'][0]['st_validation_name']}}</label>
            </li>
          </ul>
        </div>
        <!-- <div class="edit_box" v-if="controlData.length>=2">
          <div v-for="(control,index) in inIsParent" :key="index">
            <h4
              class="edit_head"
              v-show="control['in_question_validation_id'] == 1 && control['in_is_parent']"
              v-if="questionData.validationDetails.childVid == 0 ? setDefaultActiveChild(control['details'][0]['in_validation_id'])  : 1 "
            >Options</h4>
            <h4
              class="edit_head"
              v-show="(control['in_question_validation_id'] == 88 || control['in_question_validation_id'] == 95) && control['in_is_parent']"
              v-if="questionData.validationDetails.childVid == 0 ? setDefaultActiveChild(control['details'][0]['in_validation_id'])  : 1 "
            >Ending Scenerio</h4>
            <ul class="question_select" v-show="control['in_is_parent']">
              <li>
                <input
                    type="radio"
                    :id="'qtypechild_'+index"
                    name="question_selected"
                    v-bind:checked="index == activeChildTab ? '1':''"
                    @input="updateChildTab($event,control['details'][0]['in_validation_id'])"
                >
                <label :for="'qtypechild_'+index">
                  {{control['details'][0]['st_validation_name']}}
                </label>
              </li>
            </ul>
          </div>
        </div>-->
        <!-- For text input and end screen control as have child validations -->
        <div v-if="inIsParent[activeChildTab] && inIsParent[activeChildTab]['in_is_parent']">
          <div
            :class="[vueQueValidationConfig.VALIDATION_MIN_CHAR, vueQueValidationConfig.VALIDATION_MAX_CHAR, vueQueValidationConfig.VALIDATION_MIN_NUM,vueQueValidationConfig.VALIDATION_MAX_NUM].includes(childValidations['validation_details']['in_validation_id'])  ? 'question_type_select active min-max-textbox' : [vueQueValidationConfig.VALIDATION_MANDATORY_QUE, vueQueValidationConfig.VALIDATION_ALLOW_OTHER_ANS, vueQueValidationConfig.VALIDATION_ALLOW_DECIMAL_NUM, vueQueValidationConfig.VALIDATION_ALLOW_MORE_THAN_ONE_ANS,vueQueValidationConfig.VALIDATION_SHOW_ANS_LABEL,vueQueValidationConfig.VALIDATION_EMAIL_SURVEY_RESULTS,vueQueValidationConfig.VALIDATION_SHOW_TITLE,vueQueValidationConfig.VALIDATION_ACCESS_TO_GALLERY,vueQueValidationConfig.VALIDATION_ADDRESS_QUE].includes(childValidations['validation_details']['in_validation_id'])  ? 'question_type_select active radio-box other-options' : 'question_type_select active'"
            v-for="(childValidations,index1) in inIsParent[activeChildTab]['details'][0]['parentValidationDetail']"
            :key="index1"
          >
            <div
              class="edit_box topPicker"
              v-if="childValidations['validation_details']['in_validation_id'] == vueQueValidationConfig.VALIDATION_MIN_CHAR"
            >
              <h4 class="edit_head">{{childValidations['validation_details']['st_validation_name']}}</h4>
              <input
                key="2"
                @change="inputChanged"
                v-validate.initial="questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_CHAR] ? 'numeric|max_value:'+questionData.validationDetails[vueQueValidationConfig.VALIDATION_MAX_CHAR] : 'numeric'"
                name="2"
                data-vv-as="Min Value"
                v-model="questionData.validationDetails[''+childValidations['validation_details']['in_validation_id']]"
                type="number"
                class="form-control"
              />
              <span class="error" v-if="errors.has('2')">{{ errors.first('2') }}</span>
            </div>
            <div
              class="edit_box bottomPicker"
              v-if="childValidations['validation_details']['in_validation_id']== vueQueValidationConfig.VALIDATION_MAX_CHAR"
            >
              <h4 class="edit_head">{{childValidations['validation_details']['st_validation_name']}}</h4>
              <input
                key="3"
                @change="inputChanged"
                v-validate.initial="questionData.validationDetails[vueQueValidationConfig.VALIDATION_MIN_CHAR] ? 'numeric|min_value:'+questionData.validationDetails[vueQueValidationConfig.VALIDATION_MIN_CHAR] : 'numeric'"
                name="3"
                data-vv-as="Max Value"
                v-model="questionData.validationDetails[''+childValidations['validation_details']['in_validation_id']]"
                type="number"
                class="form-control"
              />
              <span class="error" v-if="errors.has('3')">{{ errors.first('3') }}</span>
            </div>
            <div
              class="edit_box answer_btn"
              v-if="childValidations['validation_details']['in_validation_id']==vueQueValidationConfig.VALIDATION_MANDATORY_QUE"
            >
              <!-- <h4 class="edit_head other-options-head">Controls</h4> -->
              <div class="space-align">
              <label class="switch">
                <input
                  @change="inputChanged"
                  v-model="questionData.validationDetails[''+childValidations['validation_details']['in_validation_id']]"
                  type="checkbox"
                />
                <span class="slider round"></span>
              </label>
              <p>{{childValidations['validation_details']['st_validation_name']}}</p>
              </div>
            </div>
            <div
              class="edit_box allow_char_sec"
              v-if="childValidations['validation_details']['in_validation_id']==vueQueValidationConfig.VALIDATION_ALLOWED_CHAR"
            >
              <h4 class="edit_head">{{childValidations['validation_details']['st_validation_name']}}</h4>
              <div
                class="ck-button"
                v-for="(allowChar, index) in childValidations['validation_details']['st_validation_value'].split('sep')"
                :key="index"
              >
                <label class="ck-label">
                  <input
                    v-validate="'allowcharsChecked:'+questionData.validationDetails[''+childValidations['validation_details']['in_validation_id']+' allowChar ' + allowChar]"
                    name="10"
                    hidden
                    data-vv-rules="allowcharsChecked:checked"
                    data-vv-as="checkbox"
                    @change="inputChanged"
                    v-model="questionData.validationDetails[''+childValidations['validation_details']['in_validation_id']+' allowChar ' + allowChar]"
                    type="checkbox"
                  />
                  <span class="ck-span">{{allowChar}}</span>
                </label>
              </div>
              <div class="clearfix"></div>
              <span class="error" v-if="errors.has('10')">{{ errors.first('10') }}</span>
            </div>

            <div
              class="edit_box answer_btn"
              v-if="childValidations['validation_details']['in_validation_id'] == vueQueValidationConfig.VALIDATION_ADDRESS_QUE"
            >
            <div class="space-align">
              <label class="switch">
                <input
                  :key="questionData.validationDetails[''+childValidations['validation_details']['in_validation_id']]"
                  @change="inputChanged"
                  v-model="questionData.validationDetails[''+childValidations['validation_details']['in_validation_id']]"
                  type="checkbox"
                />
                <span class="slider round"></span>
              </label>
              <p>{{childValidations['validation_details']['st_validation_name']}}</p>
            </div>
            </div>

            <!-- For end screen timeout child validation -->
            <div
              class="edit_box"
              v-if="childValidations['validation_details']['in_validation_id']== vueQueValidationConfig.VALIDATION_TIMEOUT_IN_SEC "
            >
              <h4 class="edit_head">{{childValidations['validation_details']['st_validation_name']}}</h4>
              <div class="ck-button" v-for="i in 10" :key="i">
                <label class="ck-label">
                  <input
                    v-validate.initial="'required'"
                    :name="childValidations['validation_details']['in_validation_id']"
                    data-vv-as="above"
                    @change="inputChanged"
                    v-model="questionData.validationDetails[''+childValidations['validation_details']['in_validation_id']]"
                    type="radio"
                    hidden
                    v-bind:value="i"
                  />
                  <span class="ck-span">{{i}}</span>
                </label>
              </div>
              <div class="clearfix"></div>
              <span class="error" v-if="errors.has('48')">{{ errors.first('48') }}</span>
            </div>
            <!-- For end screen button text -->
            <div
              class="edit_box"
              v-if="childValidations['validation_details']['in_validation_id'] === vueQueValidationConfig.VALIDATION_BUTTON_TEXT "
            >
              <h4 class="edit_head">{{childValidations['validation_details']['st_validation_name']}}</h4>
              <input
                @change="inputChanged"
                v-validate.initial="'required'"
                :name="childValidations['validation_details']['in_validation_id']"
                data-vv-as="above"
                v-model="questionData.validationDetails[''+childValidations['validation_details']['in_validation_id']]"
                type="text"
                class="form-control"
              />
              <span
                class="error"
                v-if="errors.has(''+childValidations['validation_details']['in_validation_id'])"
              >{{ errors.first(''+childValidations['validation_details']['in_validation_id']) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    </div>
    <!-- <div class="edit_box savecanclebtnsec">
      <div class="end_save_btn save_cancel">
        <a
          href="#" class="btn-cancel"
          @click.prevent="(questionUpdated === 1) ? $awn.confirm('Are you sure you want to cancel the changes?',cancelQuestion) : ''"
        >cancel</a>
        <a href="#" class="btn-whitelable" @click.prevent="(questionUpdated === 1) ? saveQuestion() : ''">
          <span>
            save
            <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
          </span>
        </a>
        <transition name="bounce">
          <div class="sucessIcon" v-if="isShowSucessIcon">
            <i aria-hidden="true" class="fa fa-check-square"></i>
          </div>
        </transition>
      </div>
    </div> -->
    <div class="modal" v-if="isModalOpen">
      <div class="modal-content">
        <a class="float-right" @click="closeModal" href="#" title="Close"><i class="fa fa-times" aria-hidden="true"></i></a>
        <template v-if="true">
          <ExcelFileDropzone @new-answers="handleNewAnswers"></ExcelFileDropzone>
        </template>
        <template v-if="newAnswersFromExcel.length > 0">
          <div class="modal-footer">
            <button class="btn btn-primary" @click="saveNewAnswers">Save New Answers</button>
            <button class="btn btn-secondary" @click="closeModal">Cancel</button>
          </div>
        </template>
      </div>
    </div>
    
    <!-- Excel Import Modal -->
    <div v-if="showExcelModal" class="modal">
      <div class="modal-content">
        <a href="#" class="float-right" @click.prevent="closeModal">×</a>
        <!-- <h3>Import Answers from Excel</h3>
        <p>Upload an Excel file with an "Answers" column to add new answers.</p> -->
        <excel-file-dropzone @new-answers="handleNewAnswers" />
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="closeModal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../../main";
import draggable from "vuedraggable";
import MultiSelect from "vue-multiselect";
import VueDatePicker from "vue2-datepicker";
import { Validator } from "vee-validate";
import XLSX from 'xlsx';
import ExcelFileDropzone from "./ExcelFileDropzone.vue";
import DynamicQuestionSettings from "./DynamicQuestionSettings.vue";
var {
  queTypeConfig,
  queValidationConfig,
  queControlConfig,
  constantCommonConfig
} = require("../../../../config/config.js");

export default {
  name: "QuestionControl",
  components: {
    VueDatePicker,
    draggable,
    MultiSelect,
    ExcelFileDropzone,
    DynamicQuestionSettings
  },
  computed: {
    ...mapGetters("editquestionEdit", [
      "getQuestionAll",
      "questionUpdated",
      "getSurveyQuestWithDetails",
      "skipLogicStartQ",
      "skipLogicEndQ",
      "skipLogicQids",
      "skipLogicEndScreen",
      "excelDataArray",
      "AnswersWithTagsDetail"
    ]),
    ...mapGetters("LeftSidebarCreate", ["all"]),
    dynamicConfigSessionData() {
      return this.$session ? this.$session.getAll() : {};
    },
    filteredBySlug: function() {
      if (this.filterWhat == "all") return this.posts;
      var self = this;
      return self.posts.filter(function(post) {
        return post.category_array.find(function(category) {
          return category.slug === "category-a";
        });
      });
    },
    inIsParent() {
      if (this.controlData[this.activeType]) {
        return this.controlData[this.activeType][
          "validation_details_ids"
        ].filter(result => {
          return result.in_is_parent == 1;
        });
      }
    },
    maxTimeOptions: function() {
      if (
        this.questionData.validationDetails[
          this.vueQueValidationConfig.VALIDATION_MAX_TIME
        ]
      ) {
        let options = {
          maxDate:
            this.activeType == 0
              ? this.moment(
                  this.questionData.validationDetails[
                    this.vueQueValidationConfig.VALIDATION_MAX_TIME
                  ],
                  "HH:mm:ss a"
                ).toDate()
              : this.moment(
                  this.questionData.validationDetails[
                    this.vueQueValidationConfig.VALIDATION_MAX_TIME
                  ],
                  "HH:mm:ss"
                ).toDate(),
          useCurrent: true,
          format: this.activeType == 0 ? "hh:mm:ss a" : "HH:mm:ss",
          showClear: true,
          showClose: true,
          enabledDates: ["2019-02-03"],
          widgetPositioning: {
            vertical: "auto",
            horizontal: "left"
          }
        };
        return options;
      } else {
        let options = {
          useCurrent: true,
          format: this.activeType == 0 ? "hh:mm:ss a" : "HH:mm:ss",
          showClear: true,
          showClose: true,
          enabledDates: ["2019-02-03"],
          widgetPositioning: {
            vertical: "auto",
            horizontal: "left"
          }
        };
        return options;
      }
    },
    minTimeOptions: function() {
      if (
        this.questionData.validationDetails[
          this.vueQueValidationConfig.VALIDATION_MIN_TIME
        ]
      ) {
        let options = {
          minDate:
            this.activeType == 0
              ? this.moment(
                  this.questionData.validationDetails[
                    this.vueQueValidationConfig.VALIDATION_MIN_TIME
                  ],
                  "HH:mm:ss a"
                ).toDate()
              : this.moment(
                  this.questionData.validationDetails[
                    this.vueQueValidationConfig.VALIDATION_MIN_TIME
                  ],
                  "HH:mm:ss"
                ).toDate(),
          useCurrent: true,
          format: this.activeType == 0 ? "hh:mm:ss a" : "HH:mm:ss",
          showClear: true,
          showClose: true,
          enabledDates: ["2019-02-03"],
          widgetPositioning: {
            vertical: "auto",
            horizontal: "right"
          }
        };
        return options;
      } else {
        let options = {
          useCurrent: true,
          format: this.activeType == 0 ? "hh:mm:ss a" : "HH:mm:ss",
          showClear: true,
          showClose: true,
          enabledDates: ["2019-02-03"],
          widgetPositioning: {
            vertical: "auto",
            horizontal: "right"
          }
        };
        return options;
      }
    }
  },
  data() {
    return {
      controlData: [],
      ansCount: [], // for terms & conditions answer
      controlId: "",
      typeLabel: "",
      className: "",
      images: [],
      activeChildTab: 0,
      activeType: 0,
      stAnswerTextList:[],
      excelData:[],
      answerData:[],
      isModalOpen: false,
      // time1: '',
      // time2: '',
      lang: {
        days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        months: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        pickers: [
          "next 7 days",
          "next 30 days",
          "previous 7 days",
          "previous 30 days"
        ],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range"
        }
      },
      timePickerOptions: {
        start: "00:00:00",
        end: "23:30:00"
      },
      time12: "hh:mm:ss a",
      time24: "HH:mm",
      dropzoneOptionsForMultipleChoise: {
        // url: process.env.API_PATH + '/uploadImageToS3',
        url: "https://httpbin.org/get",
        method: "GET",
        // thumbnailWidth: 60,
        // thumbnailHeight: 40,
        addRemoveLinks: false,
        maxFilesize: 2,
        acceptedFiles: ".jpeg, .jpg, .png, .gif",
        // previewTemplate: this.templateForMultipleChoise(),
        previewsContainer: ".previews", // Define the container to display the previews
        headers: { "My-Awesome-Header": "header value" },
        // dictDefaultMessage: 'Drag and drop images here, or click to upload',
        thumbnailMethod: "contain",
        autoProcessQueue: false,
        uploadMultiple: true,
        parallelUploads: 100,
        maxFiles: 20,
        resizeWidth: 800,
        resizeHeight: 600,
        resizeQuality: 1,
        autoQueue: false
        // activeType1: this.length()
      },
      dropzoneOptionsForStartScreen: {
        // url: process.env.API_PATH + '/uploadImageToS3',
        url: "https://httpbin.org/get",
        method: "GET",
        addRemoveLinks: false,
        maxFilesize: 2,
        acceptedFiles: ".jpeg, .jpg, .png, .gif",
        previewsContainer: ".previews", // Define the container to display the previews
        headers: { "My-Awesome-Header": "header value" },
        thumbnailMethod: "contain",
        autoProcessQueue: false,
        maxFiles: 1,
        resizeWidth: 800,
        resizeHeight: 600,
        resizeQuality: 1,
        autoQueue: false
      },
      dropzoneOptionsForReplaceImage: {
        // url: process.env.API_PATH + '/uploadImageToS3',
        url: "https://httpbin.org/get",
        method: "GET",
        addRemoveLinks: false,
        maxFilesize: 2,
        acceptedFiles: ".jpeg, .jpg, .png, .gif",
        previewTemplate: this.templateForReplaceImage(),
        previewsContainer: ".previews", // Define the container to display the previews
        headers: { "My-Awesome-Header": "header value" },
        dictDefaultMessage: "Drag and drop images here, or click to upload",
        thumbnailMethod: "contain",
        maxFiles: 1,
        resizeWidth: 800,
        resizeHeight: 600,
        resizeQuality: 1,
        autoQueue: false,
        tempValidationDetail: ""
      },
      questionData: {
        st_question_title: "",
        // inAudit: 1,
        imageArray: [], // For uplaoding image on server [Image and Multiple Choice Question Type]
        validationDetails: {
          childVid: 0
        }
      },
      faceChanged: 0,
      deletedImageArray: [], // Image Question Type - To delete already uploaded image from server
      isLoading: false,
      isShowSucessIcon: false,
      scoreValues: [],
      scoreOthers: "",
      tempScore: "",
      vueQueTypeConfig: queTypeConfig,
      vueQueValidationConfig: queValidationConfig,
      vueQueControlConfig: queControlConfig,
      vueCommonConfig: constantCommonConfig,
      timeoptions: {
        keepOpen: true,
        debug: true,
        format: "hh:mm:ss a",
        useCurrent: true,
        showClear: true,
        showClose: true,
        //minDate: this.moment({ h: 2 }),
        maxDate: this.moment({ h: 16 }),
        widgetPositioning: {
          vertical: "auto",
          horizontal: "left"
        }
      },
      smileyClass: {
        ":)": "em em-smile",
        ":|": "em em-neutral_face",
        ":P": "em em-heart_eyes",
        ":@": "em em-angry",
        ":(": "em em-disappointed"
      },
      isLoadImage: false,
      questionSelectedChild: -1,
      mintimeDialog: false,
      maxtimeDialog: false,
      mintimeTextModel: null,
      maxtimeTextModel: null,
      saveButtonClassFlag: false,
      saveTraceyHoverClassFlag: false,
      twoMBvalidation: false,
      newAnswersFromExcel: [],
      showExcelModal: false,
    };
  },
  async mounted() {
    // Custom validation for face rating checked values
    this.$validator.extend("twoChecked", {
      getMessage: field => "At least two " + field + " needs to be checked.",
      validate: value => {
        var x = 0;
        Object.keys(this.questionData.validationDetails).forEach(key => {
          if (key.includes("39")) {
            if (
              this.questionData.validationDetails[key] === 1 ||
              this.questionData.validationDetails[key] === true
            ) {
              x++;
            }
          }
        });
        if (x >= 2) return 1;
        if (Object.keys(value).length > 1) {
          return 1;
        } else {
          return 0;
        }
      }
    });
    // For allowed characters in text serial number type(alpha/digits should be checked)
    this.$validator.extend("allowcharsChecked", {
      getMessage: field => "Either of alphabets/digits needs to be checked.",
      validate: value => {
        var x = 0;
        Object.keys(this.questionData.validationDetails).forEach(key => {
          if (
            this.questionData.validationDetails["10 allowChar A"] ||
            this.questionData.validationDetails["10 allowChar 1"]
          ) {
            x = 1;
          }
        });
        return x;
      }
    });
    // Custom validation for currency checked values
    this.$validator.extend("maxOneChecked", {
      getMessage: field => "Max one " + field + " needs to be checked.",
      validate: value => {
        var myKey = Object.keys(this.questionData.validationDetails).filter(
          function(key) {
            return key.indexOf(27) !== -1;
          }
        );
        console.log(myKey);
        if (myKey.length > 1)
          delete this.questionData.validationDetails[myKey[0]];
        return 1;
      }
    });

    // Custom validation for list control answers
    this.$validator.extend("emptyline", {
      getMessage: field =>
        field +
        " answer cannot be blank. Please enter a value for all Answer Options.",
      validate: value => {
        value.replace(/\n$/, "");
        var count = value.split(/\r*\n\s*\n+/);
        var count1 = value.split(/\r*\n/);
        if (count1[0] == "") {
          count.push("");
        }
        if (count.length >= 2) {
          return false;
        } else {
          return count.length;
        }
      }
    });

    this.$validator.extend("minlines", {
      getMessage: field => "There should be min 2 answer values.",
      validate: value => {
        console.log(123);
        console.log(value);
        console.log(this.questionData.validationDetails[6]);
        console.log(this.questionData.validationDetails[13]);
        let val = this.questionData.validationDetails[6];
        var count = val.split(/\r*\n\s*\S/).length;
        if (count >= 2) {
          return count;
        } else if (
          count == 1 &&
          this.questionData.validationDetails[13] == true
        ) {
          return count;
        } else {
          return false;
        }
      }
    });
    // Custom validation for image
    this.$validator.extend("minOneImage", {
      getMessage: field =>
        "There should be minimum 1 and maximum 4 answer value.",
      validate: value => {
        if (value.length >= 1 && value.length <= 4) {
          return true;
        } else {
          return false;
        }
      }
    });

    this.$validator.extend("minTwoImage", {
      getMessage: field =>
        "At least two images are required.",
      validate: value => {
        if (value.length >= 2) {
          return true;
        } else {
          return false;
        }
      }
    });
    this.$validator.extend("maxTwentyImage", {
      getMessage: field =>
        "There should be minimum 2 and maximum 20 images.",
      validate: value => {
        if (value.length <= 20) {
          return true;
        } else {
          return false;
        }
      }
    });
    this.$validator.extend("minTwoText", {
      getMessage: field => "There should be minimum 2 answer values.",
      validate: value => {
        if (value.length >= 2) {
          return true;
        } else {
          return false;
        }
      }
    });
    this.$validator.extend("uniqueAns", {
      getMessage: field => "Answer values should be unique.",
      validate: value => {
        var values = {},
          len = this.ansCount.length,
          i = 0;
        for (; i < len; i++) {
          if (!values[this.ansCount[i]]) values[this.ansCount[i]] = true;
          else return false;
        }
        return true;
      }
    });
    this.$validator.extend("checkTime", {
      getMessage: field => "Min time should not exceed Max time.",
      validate: value => {
        var beginningTime = this.moment(
          this.questionData.validationDetails[
            this.vueQueValidationConfig.VALIDATION_MIN_TIME
          ],
          "hh:mm:ss A"
        );
        var endTime = this.moment(
          this.questionData.validationDetails[
            this.vueQueValidationConfig.VALIDATION_MAX_TIME
          ],
          "hh:mm:ss A"
        );
        if (beginningTime.isAfter(endTime)) return false;
        return true;
      }
    });
    EventBus.$on("saveQuestionFromCenterQuestions", () => {
      this.saveQuestion();
    });
    EventBus.$on("cancelQuestionFromCenterQuestions", () => {
      this.cancelQuestion();
    });
    EventBus.$on("addClassToSaveButton", flag => {
      this.saveButtonClassFlag = flag;
    });
    EventBus.$on("addTraceyHoverToSaveButton", flag => {
      this.saveTraceyHoverClassFlag = flag;
    });

    await EventBus.$on("questionTypeSelected", qtype => {
      console.log("ooooooooooooooooooooo");
      if (qtype.id) {
        // Delete values on loading different control
        if (!qtype.created) {
          this.questionData.validationDetails = {};
          this.activeType = 0;
          this.activeChildTab = 0;
          this.questionData["options"] = "";
          this.questionData["in_question_type_id"] = "";
          this.questionData.imageArray = [];
        } else {
          // this.questionData.validationDetails = {}
          // this.questionData.validationDetails[30] = ''
          // this.questionData.validationDetails[31] = ''
          // this.questionData.validationDetails[1] = ''
        }
        // this.questionData['st_question_title'] = ''
        // this.questionData['in_question_master_id'] = qtype.in_question_master_id

        this.controlId = qtype.id;
        this.className = qtype.className;
        // let controlName = qtype.innerText.split('\n')[0]
        let controlName = qtype.controlName;
        this.typeLabel = controlName;
        //

        axios.defaults.headers.common["Authorization"] = this.$session.get(
          "jwt_token"
        );
        let url = process.env.API_PATH + "/GetAllQuestionTypeByControlId";
        axios
          .post(
            url,

            {
              responseType: "json",
              lang: this.$session.get("lang"),
              request_id: this.$session.get("requestId"),
              in_control_id: this.controlId
            },
            {
              headers: { "Content-Type": "application/json" }
            }
          )
          .then(response => {
            if (response.data.flag == 0) {
              this.$awn.alert(response.data.msg);
            } else if (response.data.flag == 1) {
              this.controlData = response.data.data;
            } else {
              this.$awn.alert(response.data.msg);
            }
          })
          .catch(e => {
            this.$awn.alert(this.$t("message.catchapiError"));
          });
      }
    });

    this.questionData.sessionData = this.$session.getAll();
    this.questionData.sessionData["in_survey_Id"] = this.$route.params.id;
  },
  watch: {
    // To know Edit was called and not create question
    getQuestionAll: function(val) {
      console.log(val);
      this.setQuestionUpdated(0);
      //this.ansCount = []
      this.errors.clear();

      this.questionData.in_question_master_id = val.in_question_master_id;
      this.questionData.st_question_title = val.st_question_title;
      this.questionData.in_question_type_id = val.in_question_type_id;
      // So that foreach is not needed in save question
      this.questionData.imageArray = [];
      this.ansCount = [];
      this.faceChanged = 0;
      if (val.is_created) {
        this.questionData.validationDetails = {};
      }
      // if (
      //   val.in_question_type_id == 1 ||
      //   val.in_question_type_id == 4 ||
      //   val.in_question_type_id == 8 ||
      //   val.in_question_type_id == 10 ||
      //   val.in_question_type_id == 19
      // ) {
      //   this.activeType = 0
      // } else
      if (
        val.in_question_type_id == this.vueQueTypeConfig.TYPE_DISPLAY ||
        val.in_question_type_id == this.vueQueTypeConfig.TYPE_TRUE_FALSE ||
        val.in_question_type_id == this.vueQueTypeConfig.TYPE_MULTIPLE_IMAGE ||
        val.in_question_type_id == this.vueQueTypeConfig.TYPE_TELEPHONE ||
        val.in_question_type_id == this.vueQueTypeConfig.TYPE_24_HOURS ||
        val.in_question_type_id == this.vueQueTypeConfig.TYPE_STAR
      ) {
        this.activeType = 1;
      } else if (
        val.in_question_type_id == this.vueQueTypeConfig.TYPE_OTHER ||
        val.in_question_type_id == this.vueQueTypeConfig.TYPE_CURRENCY
      ) {
        this.activeType = 2;
      } else {
        this.activeType = 0;
      }
      if (val.question_validation_details) {
        this.ansCount = [];
        this.scoreValues = [];
        this.scoreOthers = "";
        this.questionData.st_answer_score = "";
        this.mintimeTextModel = null;
        this.maxtimeTextModel = null;
        // this.deletedImageArray = []
        // Here in_question_validation_id represents in_validation_id field of database.
        val.question_validation_details.forEach((value, key) => {
          (value.in_question_validation_id ==
            queValidationConfig.VALIDATION_SINGLE_LINE &&
            val.in_question_type_id == this.vueQueTypeConfig.TYPE_INPUT) ||
          (value.in_question_validation_id ==
            queValidationConfig.VALIDATION_TIMEOUT &&
            val.in_question_type_id ==
              this.vueQueTypeConfig.TYPE_END_SCREEN_TEXT)
            ? ((this.activeChildTab = 0),
              (this.questionData.validationDetails["childVid"] =
                value.in_question_validation_id),
              (this.questionSelectedChild = value.in_question_validation_id))
            : value.in_question_validation_id ==
                queValidationConfig.VALIDATION_PARAGRAPH ||
              (value.in_question_validation_id ==
                queValidationConfig.VALIDATION_BUTTON &&
                val.in_question_type_id ==
                  this.vueQueTypeConfig.TYPE_END_SCREEN_TEXT)
            ? ((this.activeChildTab = 1),
              (this.questionData.validationDetails["childVid"] =
                value.in_question_validation_id),
              (this.questionSelectedChild = value.in_question_validation_id))
            : value.in_question_validation_id ==
              queValidationConfig.VALIDATION_SERIAL_NUM
            ? ((this.activeChildTab = 2),
              (this.questionData.validationDetails["childVid"] =
                value.in_question_validation_id),
              (this.questionSelectedChild = value.in_question_validation_id))
            : 1;
          if (value.question_answer_details) {
            value.question_answer_details.forEach((ans, k) => {
              if (ans.st_answer_text !== "") {
                // Allowed characters in text input
                if (
                  value.in_question_validation_id ==
                  queValidationConfig.VALIDATION_ALLOWED_CHAR
                ) {
                  let allowChar = ans.st_answer_text.split("sep");
                  for (var i = 0; i < allowChar.length; i++) {
                    this.$set(
                      this.questionData.validationDetails,
                      value.in_question_validation_id +
                        " allowChar " +
                        allowChar[i],
                      1
                    );
                  }
                } else if (
                  value.in_question_validation_id ==
                    queValidationConfig.VALIDATION_ALLOWED_TELEPHONE_CHAR ||
                  value.in_question_validation_id ==
                    queValidationConfig.VALIDATION_ALLOWED_CURRENCY_CHAR ||
                  value.in_question_validation_id ==
                    queValidationConfig.VALIDATION_FACE_RATING
                ) {
                  // Allowed currency characters and telephone characters in numbers or faces
                  let allowChar = ans.st_answer_text.split("sep");
                  for (var i = 0; i < allowChar.length; i++) {
                    if (allowChar[i] && allowChar[i] != "") {
                      this.$set(
                        this.questionData.validationDetails,
                        value.in_question_validation_id +
                          " allowChar " +
                          allowChar[i],
                        1
                      );
                    }
                  }
                } else if (
                  value.in_question_validation_id ==
                  queValidationConfig.VALIDATION_TEXT
                ) {
                  // for multiple choice text options
                  this.ansCount.push(ans.st_answer_text);
                  this.scoreValues.push(ans.st_answer_score);
                } else if (
                  value.in_question_validation_id ==
                  queValidationConfig.VALIDATION_ALLOW_OTHER_ANS
                ) {
                  // for allow other options validation score value
                  this.scoreOthers = ans.st_answer_score;
                  this.$set(
                    this.questionData.validationDetails,
                    value.in_question_validation_id,
                    ans.st_answer_text
                  );
                } else if (
                  value.in_question_validation_id ==
                  queValidationConfig.VALIDATION_IMAGE
                ) {
                  console.log(ans);
                  // for image question type
                  let obj = {};
                  // var objDataUrl = JSON.parse(ans.st_answer_text);
                  obj["image"] = JSON.parse(ans.st_answer_text);
                  obj["label"] = ans.st_answer_label;
                  obj["score"] = ans.st_answer_score;
                  // console.log(obj["image"]);
                  // let temp = this.questionData.imageArray;
                  // // console.log(typeof temp.imageArray);
                  // temp.push(obj);
                  // // this.questionData = temp;
                  // console.log(temp);
                  // this.questionData.imageArray = Object.assign({}, temp);
                  this.questionData.imageArray.push(obj);
                  console.log(this.questionData);
                  this.scoreValues.push(ans.st_answer_score);
                } else if (
                  value.in_question_validation_id ==
                  queValidationConfig.VALIDATION_MULTIPLE_SINGLE_ANS
                ) {
                  // For terms and conditions answer
                  this.ansCount.push(ans.st_answer_text);
                } else {
                  if (
                    value.in_question_validation_id ==
                      queValidationConfig.VALIDATION_YES_NO ||
                    value.in_question_validation_id ==
                      queValidationConfig.VALIDATION_TRUE_FALSE
                  ) {
                    if (ans.st_answer_score) {
                      this.questionData.st_answer_score
                        ? (this.questionData.st_answer_score +=
                            ans.st_answer_score)
                        : (this.questionData.st_answer_score =
                            ans.st_answer_score + "\n");

                      this.tempScore = this.questionData.st_answer_score;
                    }
                  } else if (
                    value.in_question_validation_id ==
                      queValidationConfig.VALIDATION_FIRST_CHOICE ||
                    value.in_question_validation_id ==
                      queValidationConfig.VALIDATION_SECOND_CHOICE
                  ) {
                    if (ans.st_answer_score) {
                      this.questionData.st_answer_score
                        ? (this.questionData.st_answer_score +=
                            ans.st_answer_score)
                        : (this.questionData.st_answer_score =
                            ans.st_answer_score + "\n");

                      this.tempScore = this.questionData.st_answer_score;
                    }
                    this.$set(
                      this.questionData.validationDetails,
                      value.in_question_validation_id,
                      ans.st_answer_text
                    );
                  } else if (
                    val.in_question_type_id ==
                      this.vueQueTypeConfig.TYPE_12_HOURS
                  ) {
                    var tpValue = this.moment(ans.st_answer_text, 'hh:mm:ss A').format('HH:mm:ss');
                    // Set time picker textbox model Value
                    if(value.in_question_validation_id == queValidationConfig.VALIDATION_MIN_TIME) {
                      this.mintimeTextModel = ans.st_answer_text;
                    } else if (value.in_question_validation_id == queValidationConfig.VALIDATION_MAX_TIME) {
                      this.maxtimeTextModel = ans.st_answer_text;
                    } else {
                      tpValue = ans.st_answer_text;
                    }
                    this.$set(
                      this.questionData.validationDetails,
                      value.in_question_validation_id,
                      tpValue
                    );
                  } else if (
                    val.in_question_type_id ==
                      this.vueQueTypeConfig.TYPE_24_HOURS
                  ) {
                    // Set time picker textbox model Value
                    if(value.in_question_validation_id == queValidationConfig.VALIDATION_MIN_TIME) {
                      this.mintimeTextModel = ans.st_answer_text;
                    } else if (value.in_question_validation_id == queValidationConfig.VALIDATION_MAX_TIME) {
                      this.maxtimeTextModel = ans.st_answer_text;
                    }
                    this.$set(
                      this.questionData.validationDetails,
                      value.in_question_validation_id,
                      ans.st_answer_text
                    );
                  } else if (
                    (value.in_question_validation_id !=
                      queValidationConfig.VALIDATION_SINGLE_LINE &&
                      value.in_question_validation_id !=
                        queValidationConfig.VALIDATION_PARAGRAPH &&
                      value.in_question_validation_id !=
                        queValidationConfig.VALIDATION_SERIAL_NUM &&
                      value.in_question_validation_id !=
                        queValidationConfig.VALIDATION_TIMEOUT &&
                      value.in_question_validation_id !=
                        queValidationConfig.VALIDATION_BUTTON) ||
                    (val.in_question_type_id !=
                      this.vueQueTypeConfig.TYPE_INPUT &&
                      val.in_question_type_id !=
                        this.vueQueTypeConfig.TYPE_END_SCREEN_TEXT)
                  ) {
                    if (!this.questionData.st_answer_score) {
                      if (ans.st_answer_score) {
                        this.questionData.st_answer_score = ans.st_answer_score;
                      }
                    }
                    if (
                      value.in_question_validation_id ===
                      queValidationConfig.VALIDATION_MANDATORY_QUE
                    ) {
                      if (
                        ans.st_answer_text == "1" ||
                        ans.st_answer_text == true
                      ) {
                        console.log(value.in_question_validation_id);
                        this.$set(
                          this.questionData.validationDetails,
                          value.in_question_validation_id,
                          true
                        );
                      } else {
                        this.$set(
                          this.questionData.validationDetails,
                          value.in_question_validation_id,
                          false
                        );
                      }
                    } else {
                      this.$set(
                        this.questionData.validationDetails,
                        value.in_question_validation_id,
                        ans.st_answer_text
                      );
                    }
                  }
                }
              }
            });
          }
        });
      }
    }
  },

  beforeDestroy() {
    EventBus.$off("questionTypeSelected");
    EventBus.$off("questionSaved");
    EventBus.$off("saveQuestionFromCenterQuestions");
    EventBus.$off("cancelQuestionFromCenterQuestions");
    EventBus.$off("addClassToSaveButton");
    EventBus.$off("addTraceyHoverToSaveButton");
  },
  methods: {
    ...mapActions("editquestionEdit", ["saveData", "setQuestionUpdated","setExcelQuestionMasterId","getSurveyQuestionAnswerWithTags","clearAnswersWithTagsDetail"]),
    updateChildTab: function(e, vid) {
      this.setQuestionUpdated(1);
      if (
        vid == queValidationConfig.VALIDATION_SERIAL_NUM &&
        (this.questionData.validationDetails.childVid ==
          queValidationConfig.VALIDATION_SINGLE_LINE ||
          (this.questionData.validationDetails.childVid ==
            queValidationConfig.VALIDATION_PARAGRAPH &&
            this.questionSelectedChild !==
              queValidationConfig.VALIDATION_SERIAL_NUM))
      ) {
        this.$set(this.questionData.validationDetails, "10 allowChar A", 1);
        this.$set(this.questionData.validationDetails, "10 allowChar 1", 1);
        this.questionData.st_answer_score = "";
      } else if (
        vid == queValidationConfig.VALIDATION_BUTTON &&
        this.questionData.validationDetails.childVid ==
          queValidationConfig.VALIDATION_TIMEOUT &&
        this.questionSelectedChild !== queValidationConfig.VALIDATION_BUTTON
      ) {
        this.$set(
          this.questionData.validationDetails,
          queValidationConfig.VALIDATION_BUTTON_TEXT,
          "End Form"
        );
      } else if (
        vid == queValidationConfig.VALIDATION_TIMEOUT &&
        this.questionData.validationDetails.childVid ==
          queValidationConfig.VALIDATION_BUTTON &&
        this.questionSelectedChild !== queValidationConfig.VALIDATION_TIMEOUT
      ) {
        this.$set(
          this.questionData.validationDetails,
          queValidationConfig.VALIDATION_TIMEOUT_IN_SEC,
          2
        );
      }
      this.questionData.validationDetails.childVid = vid;
      this.activeChildTab = e.target.id.split("qtypechild_")[1];
    },
    updateType: function(e) {
      this.setQuestionUpdated(1);
      this.clearValidationDetails();
      if (
        this.questionData["in_question_type_id"] ==
        this.vueQueTypeConfig.TYPE_DISPLAY
      ) {
        this.questionData.validationDetails.childVid = 6;
      }
      this.activeType = e.target.id.split("qtype_")[1];
      if (
        (this.activeType == 0 &&
          this.questionData["in_question_type_id"] ==
            this.vueQueTypeConfig.TYPE_YES_NO) ||
        (this.activeType == 1 &&
          this.questionData["in_question_type_id"] ==
            this.vueQueTypeConfig.TYPE_TRUE_FALSE) ||
        (this.activeType == 2 &&
          this.questionData["in_question_type_id"] ==
            this.vueQueTypeConfig.TYPE_OTHER)
      ) {
        this.questionData.st_answer_score = this.tempScore;
      } else if (
        this.activeType == 1 &&
        (this.questionData["in_question_type_id"] ==
          this.vueQueTypeConfig.TYPE_NUMBER ||
          this.questionData["in_question_type_id"] ==
            this.vueQueTypeConfig.TYPE_CURRENCY)
      ) {
        //this.questionData.validationDetails['15 allowChar +'] = 1
        this.$set(this.questionData.validationDetails, "26 allowChar +", 1);
        this.$set(this.questionData.validationDetails, "26 allowChar -", 1);
        this.$set(this.questionData.validationDetails, "26 allowChar  ", 1);
        this.$set(this.questionData.validationDetails, "26 allowChar ()", 1);
        this.$set(this.questionData.validationDetails, "26 allowChar *", 1);
        this.$set(this.questionData.validationDetails, "26 allowChar /", 1);
        this.$set(this.questionData.validationDetails, "26 allowChar #", 1);
        this.questionData.st_answer_score = "";
        this.scoreValues = [];
        this.scoreOthers = "";
      } else if (
        this.activeType == 2 &&
        (this.questionData["in_question_type_id"] ==
          this.vueQueTypeConfig.TYPE_NUMBER ||
          this.questionData["in_question_type_id"] ==
            this.vueQueTypeConfig.TYPE_TELEPHONE)
      ) {
        this.$set(
          this.questionData.validationDetails,
          queValidationConfig.VALIDATION_ALLOWED_CURRENCY_CHAR + " allowChar $",
          1
        );
      } else if (
        this.activeType == 0 &&
        this.questionData["in_question_type_id"] ==
          this.vueQueTypeConfig.TYPE_STAR
      ) {
        if (
          Object.keys(this.questionData.validationDetails).indexOf(
            queValidationConfig.VALIDATION_FACE_RATING
          ) == -1
        ) {
          this.$set(
            this.questionData.validationDetails,
            queValidationConfig.VALIDATION_FACE_RATING + " allowChar :@",
            1
          );
          this.$set(
            this.questionData.validationDetails,
            queValidationConfig.VALIDATION_FACE_RATING + " allowChar :|",
            1
          );
          this.$set(
            this.questionData.validationDetails,
            queValidationConfig.VALIDATION_FACE_RATING + " allowChar :P",
            1
          );
        }
      } else if (
        this.activeType == 1 &&
        this.questionData["in_question_type_id"] ==
          this.vueQueTypeConfig.TYPE_SATISFACTION
      ) {
        if (
          !this.questionData.validationDetails[
            queValidationConfig.VALIDATION_STAR_RATING
          ]
        )
          this.$set(
            this.questionData.validationDetails,
            queValidationConfig.VALIDATION_STAR_RATING,
            3
          );
      } else if (
        this.activeType == 0 &&
        this.questionData["in_question_type_id"] ==
          this.vueQueTypeConfig.TYPE_MULTIPLE_IMAGE
      ) {
        if (this.ansCount.length === 0) {
          this.ansCount.push("Choice 1");
          this.ansCount.push("Choice 2");
          // this.$set(this.questionData.validationDetails, queValidationConfig.VALIDATION_TEXT+' 0', ' Option 1');
          // this.$set(this.questionData.validationDetails, queValidationConfig.VALIDATION_TEXT+' 1', ' Option 2');
        }
      } else {
        // If question tye is time then change min time and max time format based on 12 hours and 24 hours
        if(this.questionData["in_question_type_id"] == this.vueQueTypeConfig.TYPE_12_HOURS || this.questionData["in_question_type_id"] == this.vueQueTypeConfig.TYPE_24_HOURS) {
          switch(this.activeType) {
            case 0:
            case "0":
              if(this.mintimeTextModel) {
                this.mintimeTextModel = this.moment(this.questionData.validationDetails[this.vueQueValidationConfig.VALIDATION_MIN_TIME], "HH:mm:ss").format("hh:mm:ss A");
              }

              if(this.maxtimeTextModel) {
                this.maxtimeTextModel = this.moment(this.questionData.validationDetails[this.vueQueValidationConfig.VALIDATION_MAX_TIME], "HH:mm:ss").format("hh:mm:ss A");
              }
              break;

            case 1:
            case "1":
              if(this.mintimeTextModel) {
                this.mintimeTextModel = this.moment(this.questionData.validationDetails[this.vueQueValidationConfig.VALIDATION_MIN_TIME], "hh:mm:ss A").format("HH:mm:ss");
              }

              if(this.maxtimeTextModel) {
                this.maxtimeTextModel = this.moment(this.questionData.validationDetails[this.vueQueValidationConfig.VALIDATION_MAX_TIME], "hh:mm:ss A").format("HH:mm:ss");
              }
              break;
          }
        }

        this.questionData.st_answer_score = "";
        this.scoreValues = [];
        this.scoreOthers = "";
      }
      // this.activeChildTab = 0
      // this.questionData.validationDetails.childVid = 0
    },
    clearValidationDetails: function(e) {
      // this.questionData.validationDetails = {}
      // this.questionData.st_question_title = ''
    },
    setDefaultActiveChild: function(e) {
      this.questionData.validationDetails.childVid = e;
    },
    callSaveMethod: function() {
      EventBus.$emit("saveQuestionFromCenterQuestions");
    },
    callCancelMethod: function() {
      EventBus.$emit("cancelQuestionFromCenterQuestions");
    },
    async openModal() {
      this.showExcelModal = true;
    },
    closeModal() {
      this.showExcelModal = false;
    },
    handleNewAnswers(answersWithPositions) {
      // Get current answers
      let currentAnswers = [];
      
      if (this.questionData.validationDetails[6]) {
        // For list type questions
        currentAnswers = this.questionData.validationDetails[6].split('\n').filter(a => a.trim());
      } else if (this.ansCount) {
        // For multiple choice questions
        currentAnswers = [...this.ansCount];
      }

      // Track statistics for user feedback
      let updated = 0;
      let added = 0;

      // Create a new array with the maximum length needed
      const maxPosition = Math.max(
        currentAnswers.length - 1,
        ...answersWithPositions.map(a => a.position)
      );
      let resultAnswers = new Array(maxPosition + 1);

      // First, copy existing answers to their positions
      currentAnswers.forEach((answer, idx) => {
        resultAnswers[idx] = answer;
      });

      // Then process new/updated answers
      answersWithPositions.forEach(({position, answer}) => {
        if (position < resultAnswers.length) {
          if (resultAnswers[position]) {
            // Position exists - update if different
            if (resultAnswers[position].toLowerCase().trim() !== answer.toLowerCase().trim()) {
              resultAnswers[position] = answer;
              updated++;
            }
          } else {
            // Position is within array but empty - add
            resultAnswers[position] = answer;
            added++;
          }
        } else {
          // Position is beyond current array - add
          resultAnswers[position] = answer;
          added++;
        }
      });

      // Filter out any undefined elements and update the question
      resultAnswers = resultAnswers.filter(answer => answer);

      if (updated === 0 && added === 0) {
        this.$awn.info('No changes needed - all answers match existing positions.');
        this.closeModal();
        return;
      }

      // Update the question with new answers
      if (this.questionData.validationDetails[6]) {
        // For list type questions
        this.questionData.validationDetails[6] = resultAnswers.join('\n');
      } else if (this.ansCount) {
        // For multiple choice questions
        this.ansCount = resultAnswers;
      }

      // Mark question as updated
      this.setQuestionUpdated(1);
      
      // Close modal
      this.closeModal();
      
      // Show success message with detailed counts
      let message = [];
      if (updated > 0) message.push(`Updated ${updated} existing answers`);
      if (added > 0) message.push(`Added ${added} new answers`);
      this.$awn.success(message.join('. ') + '.');
    },
    saveNewAnswers() {
      try {
        // Get the current question data
        let surveyDataAll = this.getSurveyQuestWithDetails;
        
        if (!surveyDataAll || !this.ExcelQuestionMasterId || !surveyDataAll[this.ExcelQuestionMasterId]) {
          this.$awn.alert("Could not find the question data. Please try again.");
          return;
        }

        let filterExcelData = surveyDataAll[this.ExcelQuestionMasterId];
        
        // Add new answers to the existing answers
        if (filterExcelData && filterExcelData.qval_6) {
          let surveyData = filterExcelData.qval_6;
          let currentAnswers = surveyData.st_answer_text ? surveyData.st_answer_text.split('\n').filter(text => text.trim()) : [];
          let updatedAnswers = [...currentAnswers, ...this.newAnswersFromExcel];
          surveyData.st_answer_text = updatedAnswers.join('\n');
        } else if (filterExcelData && filterExcelData.score_data) {
          let scoreData = filterExcelData.score_data;
          let lastScore = 0;
          
          // Find the highest score key
          if (Object.keys(scoreData).length > 0) {
            lastScore = Math.max(...Object.keys(scoreData).map(key => parseInt(key)));
          }
          
          // Add new answers with incremented scores
          this.newAnswersFromExcel.forEach((answer, index) => {
            const newKey = lastScore + index + 1;
            scoreData[newKey] = {
              st_answer_text: answer,
              in_score: 0 // Default score, adjust as needed
            };
          });
        } else {
          throw new Error('Invalid question data structure');
        }
        
        // Update the store
        this.setExcelDataArray(this.excelDataArray);
        this.setQuestionUpdated(1);
        
        // Show success message and close modal
        this.$awn.success("New answers have been added successfully!");
        this.closeModal();
      } catch (error) {
        console.error('Error saving answers:', error);
        this.$awn.alert("Error saving answers. Please try again.");
      }
    },
    async loadExcelData(){
      this.answerData['sessionData'] = this.$session.getAll();
      this.answerData['in_question_master_id'] = this.questionData.in_question_master_id;
      this.answerData['in_question_type_id'] = this.questionData.in_question_type_id;
      
      // Initialize with header
      this.stAnswerTextList = [["Answers"]];
      
      // Get current answers
      let currentAnswers = [];
      
      if (this.questionData.validationDetails[6]) {
        // For list type questions
        currentAnswers = this.questionData.validationDetails[6].split('\n').filter(a => a.trim());
      } else if (this.ansCount && this.ansCount.length > 0) {
        // For multiple choice questions
        currentAnswers = [...this.ansCount];
      } else {
        // If no current answers, add example placeholder
        currentAnswers = ["Example Answer 1", "Example Answer 2"];
      }

      // Add current answers to the list
      currentAnswers.forEach(answer => {
        if (answer && answer.trim()) {
          this.stAnswerTextList.push([answer.trim()]);
        }
      });

      // Add a few empty rows for new answers
      for (let i = 0; i < 3; i++) {
        this.stAnswerTextList.push([""]);
      }
    },
    async downloadExcel(){
      this.stAnswerTextList = [];
      await this.loadExcelData();
      
      // Ensure we have data to export
      if (!this.stAnswerTextList || this.stAnswerTextList.length === 0) {
        this.$awn.alert("No answers to export");
        return;
      }

      try {
        // Create worksheet from answers
        const worksheet = XLSX.utils.aoa_to_sheet(this.stAnswerTextList);
        
        // Set column width only if we have a valid range
        if (worksheet['!ref']) {
          const range = XLSX.utils.decode_range(worksheet['!ref']);
          if (range) {
            const cols = [];
            for (let C = range.s.c; C <= range.e.c; ++C) {
              let maxLength = 0;
              for (let R = range.s.r; R <= range.e.r; ++R) {
                const cell = worksheet[XLSX.utils.encode_cell({r: R, c: C})];
                if (cell && cell.v) {
                  maxLength = Math.max(maxLength, String(cell.v).length);
                }
              }
              cols[C] = { wch: maxLength + 2 }; // Add some padding
            }
            worksheet['!cols'] = cols;
          }
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        
        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });

        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        
        const fileName = this.getQuestionAll.st_question_title+'.xlsx';

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url);
        }
      } catch (error) {
        console.error('Error exporting Excel:', error);
        this.$awn.alert("Error creating Excel file. Please try again.");
      } finally {
        this.stAnswerTextList = [];
        this.clearAnswersWithTagsDetail();
      }
    },
    saveQuestion() {
      this.$wait.start("saving question");
      let selectedFaces = [];
      this.$validator
        .validateAll(
          {
            st_question_title: this.questionData.st_question_title,
            10: true,
            39: true,
            6: this.questionData.validationDetails[6]
          },
          { imageQuestionType: this.questionData.imageArray }
        )
        .then(() => {
          this.clearAnswersWithTagsDetail();   
          this.stAnswerTextList = [];

          if (!this.controlData || !this.controlData[this.activeType]) {
            this.$wait.end("saving question");
            this.$awn.alert("Question type data is not loaded. Please try again.");
            return;
          }

          var currentQueTypeId = this.controlData[this.activeType]["in_question_type_id"];
          console.log("saveQuestion - currentQueTypeId:", currentQueTypeId, "TYPE_IMAGE:", this.vueQueTypeConfig.TYPE_IMAGE);
          console.log("saveQuestion - imageArray:", this.questionData.imageArray, "length:", this.questionData.imageArray ? this.questionData.imageArray.length : 0);
          console.log("saveQuestion - errors.items:", this.errors.items);
          
          // Check for Display Image (TYPE_IMAGE) - must have at least 1 image
          if (
            currentQueTypeId == this.vueQueTypeConfig.TYPE_IMAGE &&
            (!this.questionData.imageArray || this.questionData.imageArray.length === 0)
          ) {
            console.log("saveQuestion - BLOCKED: TYPE_IMAGE requires at least 1 image");
            this.$wait.end("saving question");
            this.$awn.alert("Question validation details are missing.");
            return;
          }
          
          // Check for Multiple Choice Image (TYPE_MULTIPLE_IMAGE) - must have at least 2 images
          if (
            currentQueTypeId == this.vueQueTypeConfig.TYPE_MULTIPLE_IMAGE &&
            (!this.questionData.imageArray || this.questionData.imageArray.length < 2)
          ) {
            console.log("saveQuestion - BLOCKED: TYPE_MULTIPLE_IMAGE requires at least 2 images");
            this.$wait.end("saving question");
            this.$awn.alert("Question validation details are missing.");
            return;
          }
          
          // Check for Dynamic List (TYPE_DYNAMIC_LIST) - must have at least 1 service object
          if (currentQueTypeId == this.vueQueTypeConfig.TYPE_DYNAMIC_LIST) {
            var dynSettingsRef = this.$refs.dynamicSettings;
            var dynComp = Array.isArray(dynSettingsRef) ? dynSettingsRef[0] : dynSettingsRef;
            if (!dynComp || !dynComp.getDynamicConfigPayload || !dynComp.getDynamicConfigPayload()) {
              this.$wait.end("saving question");
              this.$awn.alert("Please select a contract and ensure at least one Service Object is available.");
              return;
            }
          }
          
          if (this.errors.items.length === 0) {
            if (!this.isLoading) {
              this.$Progress.start();
              // this.questionData['type'] = this.activeType
              this.isLoading = true;
              this.questionData["options"] = this.activeChildTab;
              this.questionData["in_question_type_id"] = this.controlData[
                this.activeType
              ]["in_question_type_id"];
              this.questionData["validationDetails"]["imageArray"] = []; // this.imageTypeArray
              this.questionData["deletedImageArray"] = this.deletedImageArray;

              this.questionData["allowedValidations"] = [];

              this.questionData.in_question_type_id ===
              this.vueQueTypeConfig.TYPE_INPUT
                ? this.questionData.validationDetails.childVid
                  ? ""
                  : (this.questionData.validationDetails.childVid = 6)
                : "";
              // Adding allowed validation for all questions
              this.controlData[this.activeType][
                "validation_details_ids"
              ].forEach((element, index) => {
                if (
                  element.in_is_parent &&
                  element.in_validation_id ===
                    this.questionData.validationDetails.childVid
                ) {
                  element.details[0]["parentValidationDetail"].forEach(
                    (e, i) => {
                      this.questionData["allowedValidations"].push(
                        e.in_validation_id
                      );
                    }
                  );
                }
                this.questionData["allowedValidations"].push(
                  element.in_validation_id
                );
              });
              if (this.ansCount.length) {
                let vid = "";
                this.questionData["allowedValidations"].indexOf(14) > -1
                  ? (vid = 14)
                  : (vid = 19);
                //Added below to delete all values that are set earlier and add all values again
                // Object.keys(this.questionData.validationDetails).forEach(k => {
                //   console.log(k);
                //   if (k.indexOf(vid) > -1) {
                //     delete this.questionData.validationDetails[k];
                //   }
                // });

                this.ansCount.forEach((element, index) => {
                  this.questionData.validationDetails[
                    vid + " " + index
                  ] = element;
                });
              }

              var isAuditScoreChanged = false, isOtherOptionEnabled = false;
              Object.keys(this.questionData.validationDetails).forEach(key => {
                if (key === "childVid") {
                  if (
                    this.questionData["allowedValidations"].indexOf(
                      parseInt(this.questionData.validationDetails[key])
                    ) <= -1
                  ) {
                    this.activeChildTab = 0;
                    this.questionData.validationDetails[key] = 0;
                  }
                } else if (
                  this.questionData.validationDetails[key] == true &&
                  this.questionData["allowedValidations"].indexOf(
                    parseInt(key.split(" ")[0])
                  ) <= -1
                ) {
                  delete this.questionData.validationDetails[key];
                } else if (
                  this.questionData["allowedValidations"].indexOf(
                    parseInt(key)
                  ) <= -1
                ) {
                  delete this.questionData.validationDetails[key];
                } else if (
                  this.questionData.validationDetails[key] &&
                  (key == 32 || key == 33)
                ) {
                  // else if (
                  //   this.questionData.validationDetails[key] &&
                  //   (key == 30 || key == 31)
                  // ) {
                  //   console.log("0000");
                  //   console.log(this.questionData.validationDetails[key]);
                  //   this.questionData.validationDetails[key] = this.moment(
                  //     this.questionData.validationDetails[key]
                  //   ).toDate();
                  //   this.questionData.validationDetails[key] = this.moment(
                  //     this.questionData.validationDetails[key]
                  //   ).format(
                  //     this.questionData.validationDetails[
                  //       this.vueQueValidationConfig.VALIDATION_DATE_FORMAT
                  //     ]
                  //   );

                  //   console.log(this.questionData.validationDetails[key]);
                  // }
                  if (this.activeType == 1) {
                    this.questionData.validationDetails[key] = this.moment(
                      this.questionData.validationDetails[key],
                      "hh:mm:ss A"
                    ).format("HH:mm:ss");
                  } else {
                    this.questionData.validationDetails[key] = this.moment(
                      this.questionData.validationDetails[key],
                      "hh:mm:ss A"
                    ).format("hh:mm:ss A");
                  }
                } else if (
                  !this.questionData.validationDetails[key] &&
                  key != 36 &&
                  key != 34
                ) {
                  delete this.questionData.validationDetails[key];
                } else if (
                  key == 6 &&
                  this.questionData.in_question_type_id ==
                    this.vueQueTypeConfig.TYPE_LIST &&
                  this.getSurveyQuestWithDetails[
                    this.questionData.in_question_master_id
                  ]["qval_6"]
                ) {
                  var quesValidations = this.getSurveyQuestWithDetails[this.questionData.in_question_master_id];
                  let selectedAns = this.questionData.validationDetails[key].split("\n").filter(Boolean);
                  let previousScoreData = quesValidations["qval_6"]["st_answer_text"].split("\n").filter(Boolean);
                  var previousScoreLength = previousScoreData.length;
                  var selectedAnsLength = selectedAns.length;
                  this.questionData.validationDetails[key]= selectedAns.join("\n");
//                  console.log(selectedAns)
                  let isEqual = this.getSurveyQuestWithDetails[
                    this.questionData.in_question_master_id
                  ]["qval_6"]["st_answer_text"].localeCompare(
                    this.questionData.validationDetails[key]
                  );

                  // Is Allow Other Answers is enabled currently
                  if(this.questionData.validationDetails[13]) {
                    selectedAnsLength = selectedAnsLength + 1;
                  }

                  // Is Allow Other Answers was enabled previously
                  if (quesValidations["qval_13"] && quesValidations['qval_13']['st_answer_text']) {
                    previousScoreLength = previousScoreLength + 1;
                  }

                  if (previousScoreLength != selectedAnsLength) {
                    // If we not changed any answer but enbaled Allow Other Option then we need to change audit flag
                    if(isEqual != 0) {
                      this.questionData.st_answer_score = "";
                    } else {
                      // CASE: Options in the list are same and we have just disable allow other options
                      isAuditScoreChanged = (!this.questionData.validationDetails[13]) ? false : true;
                    }

                    if(document.getElementById('13 others')) // Remove score from allow other answers
                      document.getElementById('13 others').setAttribute('data-score-value', '');
                    // this.questionData["inAudit"] = 0;
                  } else {
                    // CASE:
                    // 1 = Disable Allow Other Option and add new option in the list
                    // 2 = Enable Allow Other Option and remove existing option from the list
                    if(!this.questionData.validationDetails[13] || selectedAns.length != previousScoreData.length)
                      this.questionData.st_answer_score = "";
                    else
                      this.questionData.st_answer_score = this.getSurveyQuestWithDetails[
                        this.questionData.in_question_master_id
                      ]["qval_6"]["st_answer_score"];
                  }
                } else if (
                  key == 38 &&
                  this.getSurveyQuestWithDetails[
                    this.questionData.in_question_master_id
                  ]["qval_38"]
                ) {
                  var totalAnsScore = this.getSurveyQuestWithDetails[
                    this.questionData.in_question_master_id
                  ]["qval_38"]["st_answer_score"]
                    .split("\n");
                  isAuditScoreChanged = (parseInt(this.questionData.validationDetails[key]) != totalAnsScore.length)
                  var ans_score = totalAnsScore.splice(
                      0,
                      parseInt(this.questionData.validationDetails[key])
                    )
                    .join("\n");
                  this.questionData.st_answer_score = ans_score;
                } else if (
                  key.includes("39") &&
                  this.getSurveyQuestWithDetails[
                    this.questionData.in_question_master_id
                  ]["qval_39"]
                ) {
                  // For face rating preserve score values if checkbox are not changed
                  var arr = key.split(" ");
                  selectedFaces.push(arr[2]);
                  this.questionData.st_answer_score = this.getSurveyQuestWithDetails[
                    this.questionData.in_question_master_id
                  ]["qval_39"]["st_answer_score"];
                } else if (
                  key == 13 &&
                  (this.questionData.in_question_type_id == this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT || this.questionData.in_question_type_id == this.vueQueTypeConfig.TYPE_MULTIPLE_IMAGE)
                ) { // Multiple choice text and Multiple choice image. 13 is for allow other options
                  isOtherOptionEnabled = true;
                }
              });
              if (
                this.faceChanged === 1 &&
                this.getSurveyQuestWithDetails[
                  this.questionData.in_question_master_id
                ]["qval_39"]
              ) {
                let faceArray = this.getSurveyQuestWithDetails[
                  this.questionData.in_question_master_id
                ]["qval_39"]["st_answer_text"].split("sep");
                faceArray.sort();
                selectedFaces.sort();
                if (
                  JSON.stringify(faceArray) === JSON.stringify(selectedFaces)
                ) {
                  this.questionData.st_answer_score = this.getSurveyQuestWithDetails[
                    this.questionData.in_question_master_id
                  ]["qval_39"]["st_answer_score"];
                } else {
                  this.questionData.st_answer_score = "";
                  // this.questionData["inAudit"] = 0;
                }
              } else if (
                this.controlData[this.activeType]["in_question_type_id"] ==
                  this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT &&
                this.getSurveyQuestWithDetails[
                  this.questionData.in_question_master_id
                ]["qval_14"]
              ) { // Multiple choice text
                let multiTextScore = this.getSurveyQuestWithDetails[
                  this.questionData.in_question_master_id
                ]["qval_14"]['st_answer_score'].split("\n").filter(Boolean);
                let multipleChoiceData = this.getSurveyQuestWithDetails[
                  this.questionData.in_question_master_id
                ]['score_data'];
                let multiChoiceScoreData = Object.keys(multipleChoiceData);
                var currentAnsCount = (isOtherOptionEnabled) ? (this.ansCount.length + 1) : this.ansCount.length;
                // When we add question from left side then we get score as NA
                if(multiTextScore.indexOf('NA') == -1) {
                  this.questionData.st_answer_score = 'NA';
                } else {
                  this.questionData.st_answer_score = '';
                }

                // If we ENABLED Allow More Than One Answer option
                if(this.questionData.validationDetails[20] && this.questionData.validationDetails[20] == 1)
                  isAuditScoreChanged = true;
                // If we DISABLED Allow More Than One Answer option
                else if(this.getSurveyQuestWithDetails[this.questionData.in_question_master_id][20] && this.getSurveyQuestWithDetails[this.questionData.in_question_master_id][20]['st_answer_text'] == 1) {
                  // Case: Allow More Than One Answer = Disabled and Allow Other Answers = Enabled with no value in score data, so we need to show orange color in score icon
                  if(multipleChoiceData[multiChoiceScoreData[0]] && multipleChoiceData[multiChoiceScoreData[0]]['in_validation_id'] == 13 && multipleChoiceData[multiChoiceScoreData[0]]['st_answer_score'] == '')
                    isAuditScoreChanged = true;
                  else
                    isAuditScoreChanged = (currentAnsCount > multiChoiceScoreData.length);
                } else {
                  // If we changed Answers from third column
                  isAuditScoreChanged = (currentAnsCount > multiChoiceScoreData.length);
                }
              } else if (
                this.controlData[this.activeType]["in_question_type_id"] ==
                  this.vueQueTypeConfig.TYPE_MULTIPLE_IMAGE &&
                this.getSurveyQuestWithDetails[
                  this.questionData.in_question_master_id
                ]["qval_15"]
              ) { // Multiple choice image
                let multiTextScore = this.getSurveyQuestWithDetails[
                  this.questionData.in_question_master_id
                ]["qval_15"]['st_answer_score'].split("\n").filter(Boolean);
                let multipleChoiceData = this.getSurveyQuestWithDetails[
                  this.questionData.in_question_master_id
                ]['score_data'];
                let multiChoiceScoreData = Object.keys(multipleChoiceData);
                var currentAnsCount = (isOtherOptionEnabled) ? (this.questionData.imageArray.length + 1) : this.questionData.imageArray.length;

                // When we add question from left side then we get score as NA
                if(multiTextScore.indexOf('NA') == -1) {
                  this.questionData.st_answer_score = 'NA';
                } else {
                  this.questionData.st_answer_score = '';
                }

                // If we ENABLED Allow More Than One Answer option
                if(this.questionData.validationDetails[20] && this.questionData.validationDetails[20] == 1)
                  isAuditScoreChanged = true;
                // If we DISABLED Allow More Than One Answer option
                else if(this.getSurveyQuestWithDetails[this.questionData.in_question_master_id][20] && this.getSurveyQuestWithDetails[this.questionData.in_question_master_id][20]['st_answer_text'] == 1) {
                  // Case: Allow More Than One Answer = Disabled and Allow Other Answers = Enabled with no value in score data, so we need to show orange color in score icon
                  if(multipleChoiceData[multiChoiceScoreData[0]] && multipleChoiceData[multiChoiceScoreData[0]]['in_validation_id'] == 13 && multipleChoiceData[multiChoiceScoreData[0]]['st_answer_score'] == '')
                    isAuditScoreChanged = true;
                  else
                    isAuditScoreChanged = (currentAnsCount > multiChoiceScoreData.length);
                } else {
                  // If we changed Answers from third column
                  isAuditScoreChanged = (currentAnsCount > multiChoiceScoreData.length);
                }
              }

              // Added By Parimal 21st July 2021
              //  inAuditFlag => if we changed only answer (not other validation like required, address question etc.) then only we need to disable audit flag
              // if Survey in kiosk mode then inAuditFlag will be set to false(0).
              this.questionData.inAuditFlag = (this.all.in_survey_type == 4) ? 0 : (this.questionData.st_answer_score == '' || isAuditScoreChanged) ? 0 : 1;
              EventBus.$emit("questionSaved", this.questionData);

              // Attach dynamic config data if this is a Dynamic List question
              if (
                this.controlData[this.activeType]["in_question_type_id"] == this.vueQueTypeConfig.TYPE_DYNAMIC_LIST &&
                this.$refs.dynamicSettings
              ) {
                var dynRef = Array.isArray(this.$refs.dynamicSettings) ? this.$refs.dynamicSettings[0] : this.$refs.dynamicSettings;
                if (dynRef && dynRef.getDynamicConfigPayload) {
                  this.questionData["dynamicConfigData"] = dynRef.getDynamicConfigPayload();
                }
              }

              // If you have autoProcessQueue disabled, you'll need to call .processQueue() yourself.
              if (
                this.controlData[this.activeType]["in_question_type_id"] ==
                  this.vueQueTypeConfig.TYPE_IMAGE ||
                this.controlData[this.activeType]["in_question_type_id"] ==
                  this.vueQueTypeConfig.TYPE_START_SCREEN_TEXT ||
                this.controlData[this.activeType]["in_question_type_id"] ==
                  this.vueQueTypeConfig.TYPE_END_SCREEN_TEXT
              ) {
                // Image Question type
                // this.$refs.imageControlDropzone.processQueue()
                this.saveData(this.questionData).then(
                  value => {
                    if (this.getQuestionAll.awsImageArray) {
                      this.getQuestionAll.awsImageArray.forEach(
                        (element, index) => {
                          var obj = JSON.parse(
                            element.validationValue.st_answer_text
                          );
                          if (obj.s3ImagePath) {
                            this.questionData.imageArray[index].image[
                              "s3ImagePath"
                            ] = obj.s3ImagePath;
                          }
                        }
                      );
                    }
                    this.deletedImageArray = [];
                    // this.questionData.imageArray = []
                    if (this.$refs.imageControlDropzone[0]) {
                      this.$refs.imageControlDropzone[0].removeAllFiles();
                    } else if (this.$refs.imageControlDropzone) {
                      this.$refs.imageControlDropzone.removeAllFiles();
                    }
                    this.hideSucessIcon();
                  },
                  function() {
                    this.$awn.alert(
                      "There was an issue in saving the question"
                    );
                    this.hideSucessIcon();
                  }
                );
              } else if (
                this.controlData[this.activeType]["in_question_type_id"] ==
                this.vueQueTypeConfig.TYPE_MULTIPLE_IMAGE
              ) {
                this.ansCount = [];
                // Multiple Choise
                if (this.questionData.imageArray.length >= 2) {
                  this.saveData(this.questionData).then(value => {
                    // used to append s3ImagePath in array for deleting image from AWS
                    this.getQuestionAll.awsImageArray.forEach(
                      (element, index) => {
                        var obj = JSON.parse(
                          element.validationValue.st_answer_text
                        );
                        if (obj.s3ImagePath) {
                          this.questionData.imageArray[index].image[
                            "s3ImagePath"
                          ] = obj.s3ImagePath;
                        }
                      }
                    );
                    this.deletedImageArray = [];
                    if (this.$refs.multipleChoiceImageRef) {
                      this.$refs.multipleChoiceImageRef.removeAllFiles();
                    }
                    this.hideSucessIcon();
                  });
                } else {
                }
              } else {
                // Other Question Type
                // Clear image array if question is text in multiple choice
                if (
                  this.controlData[this.activeType]["in_question_type_id"] ==
                    this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT ||
                  this.controlData[this.activeType]["in_question_type_id"] ==
                    this.vueQueTypeConfig.TYPE_START_SCREEN_TEXT ||
                  this.controlData[this.activeType]["in_question_type_id"] ==
                    this.vueQueTypeConfig.TYPE_END_SCREEN_TEXT
                ) {
                  this.questionData.imageArray = [];
                }

                this.saveData(this.questionData).then(value => {
                  this.hideSucessIcon();
                  this.loadExcelData();
                });
                this.setQuestionUpdated(0);
              }
            }
          } else {
            this.$wait.end("saving question");
            this.$awn.alert("Question validation details are missing.");
          }
        });
    },
    cancelQuestion() {
      this.setQuestionUpdated(0);
      this.questionData.validationDetails = {};

      this.errors.clear();
      this.questionData.st_question_title = this.getQuestionAll.st_question_title;
      this.questionData.in_question_type_id = this.getQuestionAll.in_question_type_id;
      if (
        this.getQuestionAll.in_question_type_id ==
          this.vueQueTypeConfig.TYPE_DISPLAY ||
        this.getQuestionAll.in_question_type_id ==
          this.vueQueTypeConfig.TYPE_TRUE_FALSE ||
        this.getQuestionAll.in_question_type_id ==
          this.vueQueTypeConfig.TYPE_MULTIPLE_IMAGE ||
        this.getQuestionAll.in_question_type_id ==
          this.vueQueTypeConfig.TYPE_TELEPHONE ||
        this.getQuestionAll.in_question_type_id ==
          this.vueQueTypeConfig.TYPE_24_HOURS ||
        this.getQuestionAll.in_question_type_id ==
          this.vueQueTypeConfig.TYPE_STAR
      ) {
        this.activeType = 1;
      } else if (
        this.getQuestionAll.in_question_type_id ==
          this.vueQueTypeConfig.TYPE_OTHER ||
        this.getQuestionAll.in_question_type_id ==
          this.vueQueTypeConfig.TYPE_CURRENCY
      ) {
        this.activeType = 2;
      } else {
        this.activeType = 0;
      }
      if (this.getQuestionAll.question_validation_details) {
        this.ansCount = [];
        this.scoreValues = [];
        this.scoreOthers = "";
        this.questionData.st_answer_score = "";
        this.mintimeTextModel = null;
        this.maxtimeTextModel = null;
        this.deletedImageArray = [];
        this.questionData.imageArray = [];
        this.getQuestionAll.question_validation_details.forEach(
          (value, key) => {
            (value.in_question_validation_id == 6 &&
              this.getQuestionAll.in_question_type_id ==
                this.vueQueTypeConfig.TYPE_INPUT) ||
            (value.in_question_validation_id == 46 &&
              this.getQuestionAll.in_question_type_id ==
                this.vueQueTypeConfig.TYPE_END_SCREEN_TEXT)
              ? ((this.activeChildTab = 0),
                (this.questionData.validationDetails["childVid"] =
                  value.in_question_validation_id))
              : value.in_question_validation_id == 8 ||
                (value.in_question_validation_id == 47 &&
                  this.getQuestionAll.in_question_type_id ==
                    this.vueQueTypeConfig.TYPE_END_SCREEN_TEXT)
              ? ((this.activeChildTab = 1),
                (this.questionData.validationDetails["childVid"] =
                  value.in_question_validation_id))
              : value.in_question_validation_id == 9
              ? ((this.activeChildTab = 2),
                (this.questionData.validationDetails["childVid"] =
                  value.in_question_validation_id))
              : 1;
            if (value.question_answer_details) {
              value.question_answer_details.forEach((ans, k) => {
                if (ans.st_answer_text != "") {
                  // Allowed characters in text input
                  if (
                    value.in_question_validation_id ==
                    queValidationConfig.VALIDATION_ALLOWED_CHAR
                  ) {
                    let allowChar = ans.st_answer_text.split("sep");
                    for (var i = 0; i < allowChar.length; i++) {
                      this.$set(
                        this.questionData.validationDetails,
                        value.in_question_validation_id +
                          " allowChar " +
                          allowChar[i],
                        1
                      );
                    }
                  }
                  // Allowed currency characters and telephone characters in numbers
                  if (
                    value.in_question_validation_id ==
                      queValidationConfig.VALIDATION_ALLOWED_TELEPHONE_CHAR ||
                    value.in_question_validation_id ==
                      queValidationConfig.VALIDATION_ALLOWED_CURRENCY_CHAR ||
                    value.in_question_validation_id ==
                      queValidationConfig.VALIDATION_FACE_RATING
                  ) {
                    let allowChar = ans.st_answer_text.split("sep");
                    for (var i = 0; i < allowChar.length; i++) {
                      if (allowChar[i] != " " && allowChar[i] != "") {
                        this.$set(
                          this.questionData.validationDetails,
                          value.in_question_validation_id +
                            " allowChar " +
                            allowChar[i],
                          1
                        );
                      }
                    }
                  } else if (
                    value.in_question_validation_id ==
                    queValidationConfig.VALIDATION_TEXT
                  ) {
                    // for multiple choice text options
                    this.ansCount.push(ans.st_answer_text);
                    this.scoreValues.push(ans.st_answer_score);
                  } else if (
                    value.in_question_validation_id ==
                    queValidationConfig.VALIDATION_IMAGE
                  ) {
                    // for image question type
                    var obj = {};
                    // var objDataUrl = JSON.parse(ans.st_answer_text);
                    obj["image"] = JSON.parse(ans.st_answer_text);
                    obj["label"] = ans.st_answer_label;
                    obj["score"] = ans.st_answer_score;

                    this.questionData.imageArray.push(obj);
                    this.scoreValues.push(ans.st_answer_score);
                  } else if (
                    value.in_question_validation_id ==
                    queValidationConfig.VALIDATION_MULTIPLE_SINGLE_ANS
                  ) {
                    // For terms and conditions answer
                    this.ansCount.push(ans.st_answer_text);
                  } else {
                    if (
                      value.in_question_validation_id ==
                        queValidationConfig.VALIDATION_YES_NO ||
                      value.in_question_validation_id ==
                        queValidationConfig.VALIDATION_TRUE_FALSE
                    ) {
                      if (ans.st_answer_score) {
                        this.questionData.st_answer_score
                          ? (this.questionData.st_answer_score +=
                              ans.st_answer_score)
                          : (this.questionData.st_answer_score =
                              ans.st_answer_score + "\n");

                        this.tempScore = this.questionData.st_answer_score;
                      }
                    } else if (
                      value.in_question_validation_id ==
                        queValidationConfig.VALIDATION_FIRST_CHOICE ||
                      value.in_question_validation_id ==
                        queValidationConfig.VALIDATION_SECOND_CHOICE
                    ) {
                      if (ans.st_answer_score) {
                        this.questionData.st_answer_score
                          ? (this.questionData.st_answer_score +=
                              ans.st_answer_score)
                          : (this.questionData.st_answer_score =
                              ans.st_answer_score + "\n");

                        this.tempScore = this.questionData.st_answer_score;
                      }
                      this.$set(
                        this.questionData.validationDetails,
                        value.in_question_validation_id,
                        ans.st_answer_text
                      );
                    } else if (
                      this.getQuestionAll.in_question_type_id ==
                      this.vueQueTypeConfig.TYPE_12_HOURS
                    ) {
                      var tpValue = this.moment(ans.st_answer_text, 'hh:mm:ss A').format('HH:mm:ss');
                      // Set time picker textbox model Value
                      if(value.in_question_validation_id == queValidationConfig.VALIDATION_MIN_TIME) {
                        this.mintimeTextModel = ans.st_answer_text;
                      } else if (value.in_question_validation_id == queValidationConfig.VALIDATION_MAX_TIME) {
                        this.maxtimeTextModel = ans.st_answer_text;
                      } else {
                        tpValue = ans.st_answer_text;
                      }
                      this.$set(
                        this.questionData.validationDetails,
                        value.in_question_validation_id,
                        tpValue
                      );
                    } else if (
                      this.getQuestionAll.in_question_type_id ==
                        this.vueQueTypeConfig.TYPE_24_HOURS
                    ) {
                      // Set time picker textbox model Value
                      if(value.in_question_validation_id == queValidationConfig.VALIDATION_MIN_TIME) {
                        this.mintimeTextModel = ans.st_answer_text;
                      } else if (value.in_question_validation_id == queValidationConfig.VALIDATION_MAX_TIME) {
                        this.maxtimeTextModel = ans.st_answer_text;
                      }
                      this.$set(
                        this.questionData.validationDetails,
                        value.in_question_validation_id,
                        ans.st_answer_text
                      );
                    } else if (
                      (value.in_question_validation_id !=
                        queValidationConfig.VALIDATION_SINGLE_LINE &&
                        value.in_question_validation_id !=
                          queValidationConfig.VALIDATION_PARAGRAPH &&
                        value.in_question_validation_id !=
                          queValidationConfig.VALIDATION_SERIAL_NUM &&
                        value.in_question_validation_id !=
                          queValidationConfig.VALIDATION_TIMEOUT &&
                        value.in_question_validation_id !=
                          queValidationConfig.VALIDATION_BUTTON) ||
                      (this.getQuestionAll.in_question_type_id !=
                        this.vueQueTypeConfig.TYPE_INPUT &&
                        this.getQuestionAll.in_question_type_id !=
                          this.vueQueTypeConfig.TYPE_END_SCREEN_TEXT)
                    ) {
                      if (!this.questionData.st_answer_score) {
                        if (ans.st_answer_score) {
                          this.questionData.st_answer_score =
                            ans.st_answer_score;
                        }
                      }
                      this.$set(
                        this.questionData.validationDetails,
                        value.in_question_validation_id,
                        ans.st_answer_text
                      );
                    }
                  }
                }
              });
            }
          }
        );
      }
    },
    incAnsCount() {
      let arrSize = this.ansCount.length;
      if (arrSize < 4) {
        if (this.ansCount.indexOf("") < 0) {
          this.ansCount.push("");
        }
      } else {
        this.$awn.alert("You cannot add more answers.Reached maximuim limit.");
      }
    },
    incMultipleChoiceAnsCount() {
      let arrSize = this.ansCount.length;
      if (this.ansCount.indexOf("") < 0) {
        this.ansCount.push("");
        // this.$set(this.ansCount, arrSize , ' ')
      }
    },
    deleteAnswer(index) {
      if (this.ansCount.length > 1) {
        this.ansCount.splice(index, 1);
        this.setQuestionUpdated(1);
        this.errors.clear();
      }
    },
    deleteMultipleChoiceAnswer(index) {
      if (this.ansCount.length > 2) {
        this.ansCount.splice(index, 1);
        this.scoreValues.splice(index, 1);
        this.setQuestionUpdated(1);
        this.errors.clear();
      }
    },
    deleteImage(index, value) {
      this.questionData.imageArray.splice(index, 1);
      this.setQuestionUpdated(1);
      // Used to delete already uploaded image on AWS S3 Bucket
      if (value.image.s3ImagePath) {
        this.deletedImageArray.push(value.image.s3ImagePath);
      }
    },
    deleteMultipleChoiceImage(index, value) {
      this.questionData.imageArray.splice(index, 1);
      this.setQuestionUpdated(1);
      // Used to delete already uploaded image on AWS S3 Bucket
      if (value.image.s3ImagePath) {
        this.deletedImageArray.push(value.image.s3ImagePath);
      }
    },
    templateForMultipleChoise: function() {
      return '<div class="displayNone"></div>';
    },
    templateForImage: function() {
      return '<div class="displayNone"></div>';
    },
    templateForReplaceImage: function() {
      return `<div class="displayNone"></div>`;
    },
    base64ToFile(dataURI, width, height, origFile) {
      var byteString, mimestring;

      if (dataURI.split(",")[0].indexOf("base64") !== -1) {
        byteString = atob(dataURI.split(",")[1]);
      } else {
        byteString = decodeURI(dataURI.split(",")[1]);
      }

      mimestring = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

      var content = new Array();
      for (var i = 0; i < byteString.length; i++) {
        content[i] = byteString.charCodeAt(i);
      }

      var newFile = new File([new Uint8Array(content)], origFile.name, {
        type: mimestring
      });

      // Copy props set by the dropzone in the original file
      var origProps = [
        "dataURL",
        "width",
        "height",
        "upload",
        "status",
        "previewElement",
        "previewTemplate",
        "accepted"
      ];

      $.each(origProps, function(i, p) {
        switch (p) {
          case "dataURL":
            newFile[p] = dataURI;
            break;
          case "width":
            newFile[p] = width;
            break;
          case "height":
            newFile[p] = height;
            break;
          default:
            newFile[p] = origFile[p];
        }
      });

      return newFile;
    },
    onAdded(files, index) {
      this.setQuestionUpdated(1);
      var dropzone;
      if (this.$refs.multipleChoiceImageRef) {
        // var serialNumber = files.previewElement.querySelectorAll(".serial_number")[0]
        // serialNumber.innerHTML = 1
        dropzone = this.$refs.multipleChoiceImageRef.dropzone;
      } else if (
        this.$refs.replaceStartImageRef &&
        this.$refs.replaceStartImageRef[0]
      ) {
        dropzone = this.$refs.replaceStartImageRef[0];
      } else {
        // this.errors.clear();
        dropzone = this.$refs.imageControlDropzone[0]
          ? this.$refs.imageControlDropzone[0].dropzone
          : this.$refs.imageControlDropzone.dropzone;
      }
      // if (files.size < 2097152 && dropzone.files.length <= 20) {
      if (files.size < 2097152 && this.questionData.imageArray.length < 20) {
        this.twoMBvalidation = false;
        var MAX_WIDTH =
          this.dropzoneOptionsForMultipleChoise.resizeWidth || 800;
        var MAX_HEIGHT =
          this.dropzoneOptionsForMultipleChoise.resizeHeight || 600;
        var IMG_QUALITY =
          this.dropzoneOptionsForMultipleChoise.resizeQuality || 0.8;
        var reader = new FileReader();

        // Convert file to img
        reader.addEventListener("load", event => {
          var origImg = new Image();
          origImg.src = event.target.result;

          origImg.addEventListener("load", event => {
            var width = event.target.width;
            var height = event.target.height;
            var obj = {};

            if (height > width) {
              // Vertical Image
              MAX_WIDTH = 720;
              MAX_HEIGHT = 960;
            } else {
              // Landscape Image
              MAX_WIDTH = 960;
              MAX_HEIGHT = 720;
            }

            // Don't resize if it's small enough
            if (width <= MAX_WIDTH && height <= MAX_HEIGHT) {
              // dropzone.enqueueFile(files)
              if (typeof index === "undefined") {
                setTimeout(() => {
                  if (files.dataURL) {
                    obj["image"] = files;
                    obj["label"] = "";
                    this.questionData.imageArray.push(obj);
                  }
                }, 700);
              } else {
                // For replace image with new image
                setTimeout(() => {
                  if (this.questionData.imageArray[index].image.s3ImagePath) {
                    this.deletedImageArray.push(
                      this.questionData.imageArray[index].image.s3ImagePath
                    );
                  }
                  this.questionData.imageArray[index].image = files;
                }, 100);
              }

              return;
            }

            // Calc new dims otherwise
            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }

            // Resize
            var canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(origImg, 0, 0, width, height);

            var resizedFile = this.base64ToFile(
              canvas.toDataURL("image/jpeg", IMG_QUALITY),
              width,
              height,
              files
            );

            var origFileIndex = dropzone.files.indexOf(files);
            dropzone.files[origFileIndex] = resizedFile;

            // Enqueue added file manually making it available for
            // further processing by dropzone
            // dropzone.enqueueFile(resizedFile)
            // this.questionData.imageArray.push(resizedFile) // Is used for creating validationDetails array. Array that consist set of information to save data in database
            if (typeof index === "undefined") {
              obj["image"] = resizedFile;
              obj["label"] = "";
              this.questionData.imageArray.push(obj);
            } else {
              // For replace image with new image
              if (this.questionData.imageArray[index].image.s3ImagePath) {
                this.deletedImageArray.push(
                  this.questionData.imageArray[index].image.s3ImagePath
                );
              }
              this.questionData.imageArray[index].image = resizedFile;
            }
          });
        });
        reader.readAsDataURL(files);
      }
    },
    onError(file, message) {
      if(file.size >= 2097152)
      {
        this.twoMBvalidation = message;
      }
      // Dynamically add error message tooltip
      // var imageContainer = file.previewTemplate.getElementsByClassName('tooltip-container')[0]
      // var span = document.createElement('span')
      // span.classList.add('tooltiptext')
      // span.innerHTML = message
      // imageContainer.appendChild(span)
      // imageContainer.classList.add('image-overlay')
    },
    onSort() {
      this.setQuestionUpdated(1);
      this.$validator.validateAll();
    },
    inputChanged(e) {
      if (e && e.target.name == "39") {
        this.faceChanged = 1;
      }
      this.setQuestionUpdated(1);
    },
    hideSucessIcon() {
      this.isLoading = false;
      this.isShowSucessIcon = true;
      this.$wait.end("saving question");
      this.$Progress.finish();
      setTimeout(() => {
        this.isShowSucessIcon = false;
      }, 2000);
    },
    showPopup(e) {
      if (this.$refs.datepicker1 && this.$refs.datepicker1.closePopup) {
        this.$refs.datepicker1.closePopup();
      }
      if (this.$refs.datepicker2 && this.$refs.datepicker2.closePopup) {
        this.$refs.datepicker2.closePopup();
      }

      // Open the one that's being focused
      const targetInput = e && e.target;

      if (
        targetInput &&
        this.$refs.datepicker1 &&
        this.$refs.datepicker1.$el &&
        this.$refs.datepicker1.$el.contains(targetInput) &&
        this.$refs.datepicker1.showPopup
      ) {
        this.$refs.datepicker1.showPopup();
      } else if (
        targetInput &&
        this.$refs.datepicker2 &&
        this.$refs.datepicker2.$el &&
        this.$refs.datepicker2.$el.contains(targetInput) &&
        this.$refs.datepicker2.showPopup
      ) {
        this.$refs.datepicker2.showPopup();
      }
    },
    imgloaded() {
      console.log("m loaded");
      this.isLoadImage = true;
    },
    setTimePickerValue(dialogName, validation) {
      if(this.questionData.validationDetails[''+validation]) {
        // This dialog is used to fill vuetify dialog if v-model is not blank
        this.$refs[dialogName][0].save(this.questionData.validationDetails[validation]);

        // Convert time format from 12 hour into 24 hour becuase vuetify time picker accept only 24 hour format
        var tpValue = '';
        if(this.activeType == 0) {
          tpValue = this.moment(this.questionData.validationDetails[validation], 'HH:mm:ss').format('hh:mm:ss A');
        } else {
          tpValue = this.questionData.validationDetails[validation];
        }

        if(dialogName == 'dialog_mintime')
          this.mintimeTextModel = tpValue;
        else
          this.maxtimeTextModel = tpValue;

        this.setQuestionUpdated(1);
      } else {
        this.questionData.validationDetails[''+validation] = null;
        if(dialogName == 'dialog_mintime') {
          this.mintimeTextModel = null;
          this.mintimeDialog = false;
        } else {
          this.maxtimeTextModel = null;
          this.maxtimeDialog = false;
        }
      }
    },
    clearTimepickerValue(validation) {
      this.questionData.validationDetails[''+validation] = null;
      this.setQuestionUpdated(1);
    },
    showTopLoader() {
      this.$Progress.start();
      setTimeout(() => {
        this.$Progress.finish();
      }, 500);
    },
    validateAndShowTopLoader() {
      // When questionUpdated is 0 (no changes made), still validate image questions
      var currentQueTypeId = this.controlData[this.activeType] ? this.controlData[this.activeType]["in_question_type_id"] : null;
      
      // TYPE_IMAGE must have at least 1 image
      if (
        currentQueTypeId == this.vueQueTypeConfig.TYPE_IMAGE &&
        (!this.questionData.imageArray || this.questionData.imageArray.length === 0)
      ) {
        this.$awn.alert("Question validation details are missing.");
        return;
      }
      
      // TYPE_MULTIPLE_IMAGE must have at least 2 images
      if (
        currentQueTypeId == this.vueQueTypeConfig.TYPE_MULTIPLE_IMAGE &&
        (!this.questionData.imageArray || this.questionData.imageArray.length < 2)
      ) {
        this.$awn.alert("Question validation details are missing.");
        return;
      }
      
      this.showTopLoader();
    },
    // restrictAlphabets(e) {
    //   console.log("pp");
    //   console.log(e);
    //   // var x = e.keycode;
    //   // if ((x >= 48 && x <= 57) || x == 8 || (x >= 35 && x <= 40) || x == 46)
    //   //   return true;
    //   // else return false;
    // }
  }
};
</script>
<style lang="scss">
@import "vuetify/dist/vuetify.min.css";
</style>
<style scoped>
.v-lazy-image {
  filter: blur(5px);
  transition: filter 1.6s;
  will-change: filter;
}
.v-lazy-image-loaded {
  filter: blur(0);
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;

}

.float-right {
    position: absolute;
    top: 0px ;
    right: 5px;
    padding: 10px; 
    color: #000; 
    text-decoration: none; 
  }

.modal-content {
  background-color:#e0e0e0;
  padding: 35px;
  border-radius: 5px;
  width: 500px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 600px;
  position: relative;
}

.modal-footer {
  margin-top: 20px;
  text-align: right;
}

.modal-footer button {
  margin-left: 10px;
}

.float-right {
  float: right;
  color: #666;
  text-decoration: none;
}

.float-right:hover {
  color: #000;
}
.question_type_option {
    margin: 0 15px 15px !important;
}

</style>




// WEBPACK FOOTER //
// src/components/Dashboard/RightBarComponents/QuestionControl.vue